export default {
    "sidebar": {
        "globalTemplates": "Globale Vorlagen",
        "profileSaveError": "Fehler beim Speichern des Profils: {{msg}}",
        "mfaDisableError": "MFA konnte nicht deaktiviert werden: {{msg}}",
        "title": "CAF Suite",
        "dashboard": "Bewertungsübersicht",
        "learningHub": "Lern-Hub",
        "assessments": "Bewertungen",
        "prioritization": "Priorisierung",
        "admin": "Admin",
        "contentManagement": "Inhaltsverwaltung",
        "user": "Benutzerverwaltung",
        "settings": "Einstellungen",
        "superAdmin": "Mandantenverwaltung",
        "logout": "Abmelden",
        "editProfile": "Profil bearbeiten",
        "menu": "Menü",
        "projectManagement": "Projektmanagement",
        "assessmentSection": "Bewertung",
        "security": "Sicherheit",
        "mfaStatus": {
            "active": "Aktiv",
            "activeEnforced": "Aktiv (Erforderlich)",
            "notSetup": "Nicht eingerichtet",
            "disable": "Deaktivieren",
            "setup": "Einrichten"
        },
        "myTasks": "Meine Aufgaben",
        "online": "Online",
        "offline": "Offline",
        "eMail": "E-Mail",
        "benachrichtigungen": "Benachrichtigungen",
        "kommentareErwaehnungen": "Kommentare & Erwähnungen",
        "sofortBenachrichtigen": "Sofort benachrichtigen",
        "taeglicheZusammenfassung": "Tägliche Zusammenfassung",
        "keineEMails": "Keine E-Mails",
        "erinnerungen": "Erinnerungen",
        "faelligeAufgabenMassnahmen": "Fällige Aufgaben & Massnahmen",
        "erhaltenSieEMailsWenn": "Erhalten Sie E-Mails, wenn das Erinnerungsdatum erreicht ist.",
        "ihrName": "Ihr Name",
        "mfaDeaktivieren": "MFA deaktivieren?",
        "mfaDeaktiviert": "MFA deaktiviert",
        "portfolio": "Projektportfolio",
        "languageSettings": "Sprache",
        "twoFactorAuth": "2-Faktor-Authentifizierung",
        "mfaDisableConfirmMessage": "Möchten Sie die 2-Faktor-Authentifizierung wirklich deaktivieren? Ihr Konto ist dann weniger geschützt.",
        "mfaDisableConfirmButton": "Deaktivieren",
        "mfaDisableSuccessMessage": "Die 2-Faktor-Authentifizierung wurde erfolgreich deaktiviert.",
        "assessment": "Bewertungen",
        "tasks": "Aufgaben",
        "userManagement": "Benutzerverwaltung"
    },
    "header": {
        "dashboard": "Bewertungsübersicht",
        "learning": "Lern-Hub",
        "assessment": "Bewertungen",
        "prioritization": "Priorisierung der Potenziale",
        "contentManagement": "Inhaltsverwaltung"
    },
    "mfa": {
        "setupTitle": "2-Faktor-Authentifizierung einrichten",
        "setupSubtitle": "Erhöhen Sie die Sicherheit Ihres Kontos",
        "scanStep": "1. Code scannen",
        "appInstruction": "Öffnen Sie Ihre Authenticator App (Google Authenticator, Microsoft Authenticator o.ä.) und scannen Sie diesen Code.",
        "verifyStep": "2. Bestätigen",
        "enterCode": "Geben Sie den 6-stelligen Code ein",
        "verifyButton": "Überprüfen",
        "successMessage": "MFA erfolgreich eingerichtet!",
        "errorInvalidCode": "Ungültiger Code. Bitte versuchen Sie es erneut.",
        "setupError": "Fehler beim Einrichten der 2-Faktor-Authentifizierung. Bitte laden Sie die Seite neu.",
        "verificationTitle": "2-Faktor-Authentifizierung bestätigen",
        "verificationIntro": "Geben Sie den 6-stelligen Code aus Ihrer Authenticator App ein, um Ihre Identität zu bestätigen.",
        "emailNotVerified": "E-Mail nicht bestätigt",
        "emailNotVerifiedMessage": "Ihre E-Mail-Adresse muss bestätigt sein, bevor Sie 2FA einrichten können. Bitte prüfen Sie Ihren Posteingang oder fordern Sie eine neue E-Mail an.",
        "resendVerification": "Neue Bestätigungs-Mail senden",
        "verificationSent": "E-Mail wurde gesendet! Bitte Posteingang prüfen.",
        "verifyError": "Der Code ist ungültig. Bitte versuchen Sie es erneut.",
        "mfaNotActivated": "MFA ist für dieses Projekt noch nicht aktiviert (Identity Platform). Bitte Admin kontaktieren.",
        "emailNotVerifiedShort": "E-Mail nicht bestätigt.",
        "recentLoginRequired": "Sicherheits-Timeout: Bitte melden Sie sich erneut an, um MFA einzurichten.",
        "sendEmailError": "Fehler beim Senden der E-Mail: ",
        "activated": "2FA Aktiviert!",
        "enforcedNotice": "Ihre Organisation verlangt einen zweiten Faktor. Ohne Einrichtung können Sie die CAF Suite nicht nutzen. Sie können abbrechen und sich abmelden; bei der nächsten Anmeldung geht es hier weiter.",
        "cancelAndLogout": "Abbrechen und abmelden",
        "activatedShort": "2FA Aktiviert",
        "verifying": "Verifizieren..."
    },
    "dashboard": {
        "brushRange": "Zeitraum von {{start}} bis {{end}}",
        "overallScore": "Gesamtbewertung",
        "overallScoreDate": "Gesamtbewertung ({{date}})",
        "activeMeasures": "Aktive Massnahmen",
        "assessmentTrend": "Bewertungsübersicht",
        "compareLast": "Vergleiche letzte:",
        "assessments": "{{count}} Bewertungen",
        "breakdown": "Detailanalyse",
        "breakdownDate": "Detailanalyse ({{date}})",
        "noAssessmentData": "Keine Bewertungsdaten für das gewählte Datum.",
        "vs": "vs.",
        "startNewAssessment": "Neue Bewertung starten",
        "notAvailable": "N/V",
        "welcome": {
            "title": "Willkommen in Ihrer CAF Suite!",
            "message": "Dies ist Ihr Dashboard zur kontinuierlichen Verbesserung. Nutzen Sie das Modul Selbstbewertung, um neue Bewertungen durchzuführen.",
            "cta": "Zum Bewertungsmodul"
        },
        "kpi": {
            "score": "Aktueller Score",
            "scoreSub": "Durchschnitt (Total)",
            "potentials": "Anzahl Potenziale",
            "potentialsSub": "Aus der aktuellen Bewertung",
            "addressed": "Umgesetzte Potenziale",
            "addressedSub": "Durch ein Projekt abgedeckt"
        },
        "compareWith": "Vergleichen mit:",
        "subtitle": "Ihr Cockpit für die kontinuierliche Verbesserung.",
        "selectOrgScope": "Organisationseinheit / Auswertung",
        "scopeOwn": "Eigene Organisation",
        "scopeRollup": "Konsolidierte Sicht (Rollup)",
        "noSharedAssessmentsTitle": "Keine freigegebenen Bewertungen",
        "noSharedAssessmentsMsg": "Diese Organisationseinheit hat bisher keine Selbstbewertungen zur übergeordneten Einsicht freigegeben.",
        "tabs": {
            "nav": "Tabs",
            "status": "Statusübersicht",
            "trends": "Langzeittrends"
        },
        "analysis": {
            "title": "Langzeit-Entwicklung",
            "filter": "Analyse-Filter",
            "filterSeries": "Datenreihen filtern",
            "filterCriteria": "Kriterien filtern (aus aktiven Themen)",
            "topImprovers": "Top 3 Verbesserungen",
            "topDecliners": "Top 3 Rückgänge",
            "reset": "Zurücksetzen",
            "highlights": "Highlights im Zeitraum",
            "topDevelopments": "Top Entwicklungen",
            "biggestDeclines": "Grösste Rückgänge",
            "table": {
                "criterion": "Kriterium",
                "current": "Aktuell",
                "trend": "Trend",
                "compare": "Vergleich"
            },
            "chart": {
                "themePrefix": "Th.",
                "total": "Gesamt"
            }
        },
        "export": {
            "title": "Bericht exportieren",
            "button": "Bericht exportieren",
            "subtitle": "Wählen Sie die zu exportierenden Inhalte aus.",
            "csv": "Als CSV exportieren",
            "pdf": "PDF erstellen",
            "trendAnalysis": "Langzeit-Analyse",
            "trendDescription": "Fügt eine Analyse der Entwicklung über mehrere Bewertungen hinzu.",
            "aiAnalysis": "KI-Analyse",
            "aiDescription": "Generiert ein Management Summary und Analysen pro Themenfeld.",
            "aiDisabled": "Diese Funktion wurde von Ihrem Administrator deaktiviert.",
            "question": "Welche Inhalte sollen mit dem aktuellen Bericht ausgegeben werden?",
            "overview": "Bewertungsübersicht",
            "overviewDesc": "Fügt dem Bericht die Bewertungsübersicht (Kacheln und Spinnendiagramm) hinzu.",
            "trendAnalysisDesc": "Fügt dem Bericht das Langzeitchart, sowie die Top 3 Verbesserungen und Top 3 Rückgänge hinzu. Zudem wird wird zu jedem Kriterium ein Vergleichswert sowie der Trend angezeigt. Zum Vergleich wird die ausgewählte Vergleichsbewertung verwendet.",
            "generating": "Generiere...",
            "chartLoading": "Diagramm wird geladen..."
        },
        "errorLoadingData": "Fehler beim Laden der Daten.",
        "scopeOwnShort": "eigene Bewertungen",
        "scopeAggregate": "Aggregat der {{children}}",
        "scopeReleased": "freigegebene Bewertungen"
    },
    "learning": {
        "removeFromFavorites": "Aus Favoriten entfernen",
        "favorites": { "title": "Favoriten ansehen" },
        "cafCriteria": "CAF Themenfelder & Kriterien",
        "myFavorites": "Meine Favoriten",
        "selectSubCriterion": "Wählen Sie ein Kriterium aus, um Details anzuzeigen.",
        "bestPractices": "Beispiele",
        "aiSuggestions": "KI-Vorschläge",
        "generateIdeas": "Neue Ideen generieren",
        "generating": "Generiere...",
        "createAction": "Projekt erstellen",
        "creating": "Erstelle...",
        "addToFavorites": "Zu Favoriten hinzufügen",
        "favoritesModalTitle": "Meine Favoriten",
        "noFavorites": "Sie haben noch keine Favoriten hinzugefügt.",
        "noFavoritesHint": "Klicken Sie auf das Stern-Symbol neben einem Kriterium oder einer Methode, um es hier für den schnellen Zugriff zu speichern.",
        "subtitle": "Wissensdatenbank & Methoden für exzellente Verwaltung.",
        "tabs": {
            "knowledge": "Modell & Kriterien",
            "methods": "Methodenbaukasten"
        },
        "sections": {
            "themes": "Themenbereiche und Kriterien"
        },
        "methods": {
            "searchPlaceholder": "Methoden durchsuchen...",
            "resetTooltip": "Filter zurücksetzen",
            "reset": "Zurücksetzen",
            "allThemes": "Alle Themenfelder",
            "allCriteria": "Alle Kriterien",
            "shortDescription": "Kurzbeschrieb",
            "tips": "Tipps & Anleitung",
            "reference": "Bezug:",
            "adoptAction": "Projekt erstellen",
            "introTitle": "Einführung Methode"
        },
        "favoriteCriteria": "Favorisierte Kriterien",
        "favoriteMethods": "Favorisierte Methoden"
    },
    "validation": {
        "titleRequired": "Titel ist erforderlich",
        "descriptionRequired": "Beschreibung ist erforderlich",
        "required": "Dieses Feld ist erforderlich",
        "email": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
        "minLength": "Mindestens {{min}} Zeichen erforderlich",
        "nameRequired": "Name ist erforderlich",
        "orgRequired": "Name der Organisation ist erforderlich",
        "roleRequired": "Rolle ist erforderlich",
        "startDateBeforeDueDate": "Startdatum darf nicht nach dem Fälligkeitsdatum liegen",
        "reminderBeforeDueDate": "Erinnerungsdatum darf nicht nach dem Fälligkeitsdatum liegen"
    },
    "components": {
        "labelColon": "{{label}}:",
        "toggleDropdown": "Dropdown umschalten",
        "selectPlaceholder": "Auswählen...",
        "noOptions": "Keine Optionen verfügbar",
        "datePlaceholder": "Datum wählen",
        "weekdays": ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"],
        "monthNames": ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
        "today": "Heute",
        "clearDate": "Löschen",
        "prevMonth": "Vorheriger Monat",
        "nextMonth": "Nächster Monat",
        "prevYear": "Vorheriges Jahr",
        "nextYear": "Nächstes Jahr"
    },
    "assessment": {
        "scoreShort": {
            "enabler": {
                "noEvidence": "Keine Nachweise",
                "plan": "PLAN",
                "do": "DO",
                "check": "CHECK",
                "act": "ACT",
                "excellence": "EXCELLENCE"
            },
            "result": {
                "noResults": "Keine Ergebnisse",
                "negativeTrends": "Negative Trends",
                "stable": "Stabil",
                "improvement": "Verbesserung",
                "targetsMet": "Ziele erreicht",
                "excellence": "Exzellenz"
            }
        },
        "submitConfirmMessage": "Möchten Sie diese Bewertung wirklich einreichen? Sie wird für den Mandanten sichtbar und kann nicht mehr bearbeitet werden.",
        "bemerkungLoeschenFrage": "Möchten Sie diese Bemerkung wirklich unwiderruflich löschen?",
        "targetTenantPrompt": "Bitte geben Sie die ID des Ziel-Mandanten ein (Client ID):",
        "reportByAuthor": "Bericht von {{name}}",
        "selfAssessmentsWithReleased": "Self-Assessments",
        "selfAssessmentsWithReleasedIntro": "Ihre eigenen Selbstbewertungen und die Ihnen von unterstellten Einheiten freigegebenen (schreibgeschützt).",
        "filters": {
            "allClients": "Alle Mandanten",
            "all": "Alle",
            "draft": "Entwurf (Offen)",
            "published": "Eingereicht"
        },
        "enablerScores": {
            "0-10": "Kein Nachweis oder Ansatz vorhanden.",
            "11-30": "PLAN: Es gibt Pläne oder Ideen, aber noch keine systematische Umsetzung.",
            "31-50": "DO: Die Ansätze werden in relevanten Bereichen umgesetzt.",
            "51-70": "CHECK: Die Umsetzung wird regelmässig überprüft und gemessen.",
            "71-90": "ACT: Basierend auf Überprüfungen werden Verbesserungen vorgenommen.",
            "91-100": "EXCELLENCE: Vorbildcharakter, Benchmark, kontinuierliche Verbesserung."
        },
        "resultScores": {
            "0-10": "Keine Ergebnisse gemessen oder verfügbar.",
            "11-30": "Negative Trends oder Ziele werden nicht erreicht.",
            "31-50": "Stabile Ergebnisse oder leichte Verbesserungen.",
            "51-70": "Positive Trends über mehrere Jahre erkennbar.",
            "71-90": "Ziele erreicht/übertroffen, positive Vergleiche.",
            "91-100": "Dauerhaft herausragende Spitzenposition."
        },
        "manageAssessments": "Bewertung durchführen",
        "ownSelfAssessment": "Eigenes Self-Assessment",
        "ownSelfAssessments": "Eigene Self-Assessments",
        "ownSelfAssessmentsIntro": "Verwalten Sie Ihre eigenen Selbstbewertungen oder starten Sie einen neuen Zyklus.",
        "unassignedBannerTitle": "Unzugewiesene Bewertungen gefunden",
        "unassignedBannerDesc": "Es wurden {{count}} Bewertungen aus früheren Zyklen ohne Organisationseinheit gefunden. Weisen Sie diese jetzt Ihrer Organisationseinheit ({{unitName}}) zu:",
        "assignToMyUnitBtn": "Jetzt {{unitName}} zuweisen",
        "assignSuccessMessage": "Alle bisherigen Bewertungen wurden erfolgreich Ihrer Organisationseinheit zugewiesen und als vertraulich markiert.",
        "assignErrorMessage": "Fehler beim Zuweisen der Bewertungen.",
        "rollupDashboardTab": "Konsolidierte Auswertung (Rollup)",
        "selectOrgUnitRollup": "Organisationseinheit für Konsolidierung",
        "assessmentOverview": "Bewertungsübersicht",
        "assessmentOverviewIntro": "Verwalten Sie Ihre Selbst- und Fremdbewertungen oder starten Sie einen neuen Zyklus.",
        "newAssessment": "Neue Bewertung",
        "assessmentFrom": "Bewertung vom:",
        "deleteAssessment": "Bewertung löschen",
        "duplicate": "Duplizieren",
        "duplicatedMessage": "Bewertung dupliziert. Sie können nun Änderungen vornehmen und speichern.",
        "implementedPrefix": "Umgesetzt: ",
        "forTenant": "Für Mandant",
        "submitErrorTitle": "Fehler beim Einreichen",
        "noAssessmentsFound": "Keine Bewertungen gefunden. Starten Sie jetzt Ihre erste Selbstbewertung.",
        "resultsOverview": "Übersicht der Bewertungsergebnisse",
        "view": "Anzeigen:",
        "compareWith": "Vergleichen mit:",
        "none": "Keine (Nur Aktuelle)",
        "detailedAssessment": "Detaillierte Bewertung",
        "detailedAssessmentDate": "Detaillierte Bewertung ({{date}})",
        "addComment": "Kommentar hinzufügen...",
        "selectOrNew": "Bitte wählen Sie eine Bewertung aus, um Details anzuzeigen, oder erstellen Sie eine neue.",
        "assessmentExists": "Eine Bewertung für heute existiert bereits.",
        "showScoringGuide": "Methodik & Bewertungshilfe anzeigen",
        "backToOverview": "Zurück zur Übersicht",
        "resetScores": "Punkte zurücksetzen",
        "selfAssessment": "Selbstbewertung",
        "externalAssessment": "Fremdbewertung",
        "externalAssessmentIntro": "Historie und Management Ihrer Fremdbewertungen.",
        "publish": "Freigeben",
        "published": "Veröffentlicht",
        "draft": "Entwurf",
        "managementSummary": "Management Summary",
        "criterionRemark": "Bemerkung zum Themenfeld",
        "noExternalAssessments": "Sie haben noch keine Fremdbewertungen erstellt.",
        "readOnly": "Schreibgeschützt",
        "publishConfirmTitle": "Bewertung freigeben?",
        "publishConfirmMessage": "Sie wird für alle Benutzer der Organisation sichtbar. Fortfahren?",
        "assessmentWizard": "Bewertungs-Assistent",
        "hideAssessment": "Bewertung ausblenden",
        "unhideAssessment": "Bewertung wieder einblenden",
        "showHidden": "Ausgeblendete anzeigen",
        "hidden": "Ausgeblendet",
        "achtung": "Achtung:",
        "folgendeKriterienWurdenImAktuellen": "Folgende Kriterien wurden im aktuellen Modell inhaltlich verändert und müssen komplett neu bewertet werden:",
        "einreichen": "Einreichen",
        "wirdGespeichert": "Wird gespeichert...",
        "hinzufuegen": "Hinzufügen",
        "mandant": "Mandant",
        "status": "Status",
        "alsCsvExportieren": "Als CSV exportieren",
        "alsPdfExportieren": "Als PDF exportieren",
        "bewertungEinreichen": "Bewertung einreichen",
        "fassenSieDieWichtigstenErgebnisse": "Fassen Sie die wichtigsten Ergebnisse und Empfehlungen zusammen...",
        "fakultativeBemerkungZuDiesemThemenfeld": "Fakultative Bemerkung zu diesem Themenfeld...",
        "massnahmeErstellen": "Massnahme erstellen",
        "bearbeiten": "Bearbeiten",
        "loeschen": "Löschen",
        "staerkeVerbesserungspotenzialOderKommentarHinzufuegen": "Stärke, Verbesserungspotenzial oder Kommentar hinzufügen...",
        "linkHinzufuegenEntfernen": "Link hinzufügen/entfernen",
        "linkPlaceholder": "https://beispiel.ch oder mailto:...",
        "remarkType": "Typ",
        "remarkStrength": "Stärke",
        "remarkPotential": "Potenzial",
        "remarkInfo": "Info",
        "bemerkungLoeschen": "Bemerkung löschen",
        "rated": "bewertet",
        "complete": "fertig",
        "fillWithAI": "Mit KI befüllen",
        "zurueckZurUebersicht": "Zurück zur Übersicht",
        "infoZumKriterium": "Info zum Kriterium",
        "bewertungsassistent": "Bewertungsassistent",
        "neueBewertung": "Neue Bewertung"
    },
    "assessorDashboard": {
        "dabeiSeit": "Dabei seit: {{date}}",
        "archiveClient": "Archivieren",
        "activateClient": "Aktivieren",
        "title": "Assessor Dashboard",
        "subtitle": "Übersicht über Ihre Mandanten und Bewertungen",
        "kpiClients": "Mandanten",
        "kpiAssessments": "Bewertungen",
        "kpiDrafts": "Offene Entwürfe",
        "kpiBestScore": "Bester Score",
        "kpiWorstScore": "Schlechtester Score",
        "kpiAvgScore": "Ø Score",
        "showInactive": "Inaktive anzeigen",
        "searchPlaceholder": "Suchen...",
        "noClientsFound": "Keine Mandanten gefunden.",
        "statusInactive": "Inaktiv",
        "actionView": "Anzeigen",
        "tableHeaderClient": "Mandant",
        "tableHeaderDate": "Datum",
        "inactiveLabel": "(Inaktiv)",
        "myClients": "Meine Mandanten",
        "oldestAssessments": "Älteste Bewertungen",
        "never": "Nie",
        "errorStatusUpdate": "Fehler beim Aktualisieren des Status."
    },
    "prioritization": {
        "loadErrorAssessments": "Fehler beim Laden der Assessments.",
        "loadErrorPotentials": "Fehler beim Laden der Potenziale.",
        "loadErrorProjects": "Fehler beim Laden der Projekte.",
        "intro": "Priorisieren Sie die identifizierten Verbesserungspotenziale durch Team-Voting und Dringlichkeit (Score).",
        "noPotentials": "Keine Potenziale in der aktuellen Bewertung gefunden.",
        "scoreLabel": "Score",
        "votesLabel": "Votes",
        "createAction": "Projekt erstellen",
        "linkProject": "Projekt verknüpfen",
        "projectLinked": "In Projekt '{{project}}' überführt",
        "projectLinkedDefault": "In Projekt überführt",
        "linkProjectModalTitle": "Projekt verknüpfen",
        "linkProjectModalDesc": "Wählen Sie ein bestehendes Projekt aus, in das dieses Verbesserungspotenzial einfliessen soll.",
        "existingProject": "Bestehendes Projekt",
        "searchProject": "Projekt suchen...",
        "link": "Verknüpfen",
        "vote": "Stimme abgeben",
        "voted": "Abgestimmt",
        "highPriority": "Hohe Priorität",
        "mediumPriority": "Mittlere Priorität",
        "lowPriority": "Niedrige Priorität",
        "bereitsUmgesetzteAusblenden": "Bereits umgesetzte ausblenden",
        "kontext": "Kontext",
        "relevanz": "Relevanz?",
        "keineAktivenProjekteGefunden": "Keine aktiven Projekte gefunden.",
        "stimmeFuerDieseMassnahmeAbgeben": "Stimme für diese Massnahme abgeben",
        "basis": "Basis",
        "noProjectsForQuery": "Keine Projekte für \"{{query}}\" gefunden."
    },
    "contentManagement": {
        "methodSaveError": "Es ist ein unbekannter Fehler aufgetreten (z. B. beim Hochladen des Bildes).",
        "cleanModalMessage": "Möchten Sie wirklich alle eigenen Themenfelder, Kriterien und Beispiele löschen?",
        "filters": {
            "allThemes": "Alle Themenfelder",
            "allCriteria": "Alle Kriterien"
        },
        "title": "Inhaltsverwaltung",
        "intro": "Hier können Sie die Struktur, Themenfelder und Kriterien der CAF-Anwendung verwalten und anpassen.",
        "editTitle": "Titel bearbeiten",
        "editDescription": "Beschreibung bearbeiten",
        "saveChanges": "Änderungen speichern",
        "criterionDescription": "Beschreibung des Themenfelds",
        "subCriteria": "Kriterien",
        "bestPracticesLabel": "Beispiele",
        "bestPracticesPlaceholder": "Geben Sie jedes Beispiel in eine neue Zeile ein.",
        "addSubCriterion": "Kriterium hinzufügen",
        "addCriterion": "Neues Themenfeld hinzufügen",
        "subCriterionDescriptionPlaceholder": "Beschreibung des Kriteriums...",
        "enabler": "Befähiger",
        "result": "Ergebnis",
        "deleteCriterion": "Themenfeld löschen",
        "deleteSubCriterion": "Kriterium löschen",
        "addBestPractice": "Beispiel hinzufügen",
        "deleteBestPractice": "Löschen",
        "cleanCustomContent": "Eigene Inhalte löschen",
        "cleanModalTitle": "Eigene Inhalte löschen",
        "newTheme": "Neues Themenfeld",
        "newCriterion": "Neues Kriterium",
        "newExample": "Neues Beispiel",
        "newModule": "Neues Modul",
        "newSection": "Neue Sektion",
        "translation": {
            "readingFile": "Datei wird gelesen...",
            "invalidJson": "Ungültiges JSON-Format.",
            "unknownFileType": "Unbekannter Dateityp. Erwartet: fileType «structure» oder «methods».",
            "unsupportedLanguage": "Nicht unterstützte Zielsprache: «{{lang}}». Erlaubt: en, fr, it.",
            "validatingStructure": "Struktur-Datei wird geprüft...",
            "validatingMethods": "Methoden-Datei wird geprüft...",
            "invalidFile": "Ungültige Datei: {{detail}}",
            "insertingThemes": "Übersetzungen der Themenfelder werden eingefügt...",
            "insertingModules": "Übersetzungen der Informationsmodule werden eingefügt...",
            "insertingMethods": "Übersetzungen der Methoden werden eingefügt...",
            "savingTranslations": "Übersetzungen werden gespeichert...",
            "structureImported": "Übersetzung der Struktur ({{lang}}) erfolgreich importiert.",
            "methodsImported": "Übersetzung der Methoden ({{lang}}) erfolgreich importiert.",
            "importFailed": "Import fehlgeschlagen: {{msg}}",
            "openModal": "Übersetzung exportieren / importieren",
            "modalTitle": "Inhalte für Übersetzung",
            "modalSubtitle": "Exportieren Sie alle Texte als JSON für eine KI-Übersetzung, und importieren Sie das übersetzte Ergebnis wieder.",
            "exportTab": "Export",
            "importTab": "Import",
            "targetLanguage": "Zielsprache (Kontext für KI)",
            "importLanguage": "Sprache der Übersetzung",
            "fieldCount": "{{count}} Textfelder werden exportiert",
            "exportHint": "Laden Sie das JSON herunter und übergeben Sie es einer KI mit folgendem Prompt:",
            "aiPrompt": "Übersetze alle Texte in diesem JSON auf {{language}}. Behalte die exakte JSON-Struktur, alle Schlüssel und alle Werte der _id- und _index-Felder unverändert bei.",
            "downloadJson": "JSON herunterladen",
            "importWarningTitle": "Achtung",
            "importHint": "Bestehende Übersetzungen für diese Sprache werden überschrieben. Quell-Texte auf Deutsch bleiben unberührt.",
            "importJson": "JSON importieren",
            "importing": "Importiere...",
            "fileStructure": "Datei 1: CAF-Struktur & Informationsmodule",
            "fileMethods": "Datei 2: Methoden-Baukasten",
            "importBothHint": "Importieren Sie beide Dateien separat (Struktur-Datei und Methoden-Datei)."
        }
    },
    "login": {
        "navGesamtsicht": "Gesamtsicht",
        "needToKnowTitle": "Need-to-know zwischen Einheiten",
        "needToKnowDesc": "Jede Organisationseinheit sieht nur ihre eigenen Daten und das, was andere ihr ausdrücklich freigegeben haben. Die Zugriffsregeln setzt der Server durch, und sie werden vor jeder Auslieferung automatisch getestet.",
        "heroChips": {
            "levels": "Überblick über alle Ebenen",
            "topics": "Querschnittsthemen im Griff",
            "evidence": "Entscheide mit Fundament"
        },
        "levels": {
            "title": "Eine Plattform für alle Ebenen",
            "lead": "Projekte und Bewertungen entstehen dort, wo die Arbeit gemacht wird. Die CAF Suite bringt sie dorthin, wo entschieden wird – ohne Sammelübungen und Statusfolien.",
            "aggregateTitle": "Bewertungen verdichten",
            "aggregateDesc": "Jede Einheit bewertet sich selbst und entscheidet, wann sie ihr Ergebnis der übergeordneten Einheit freigibt. Diese sieht den Durchschnitt ihrer unterstellten Einheiten, Jahr für Jahr. Vergleiche gibt es erst ab drei Einheiten – so bleibt die Selbstbewertung ehrlich.",
            "promoteTitle": "Projekte weitergeben",
            "promoteDesc": "Was über die eigene Einheit hinaus Bedeutung hat, gibt das Portfoliomanagement Stufe für Stufe weiter: vom Amt an die Direktion, von der Direktion an den Kanton. Die Herkunft bleibt verantwortlich, jede Ebene priorisiert nach eigenen Kriterien. Nachvollziehbar bleibt, wer wann weitergegeben hat.",
            "topicsTitle": "Querschnittsthemen steuern",
            "topicsDesc": "Informatik, Nachhaltigkeit, Geodaten: Mit einem Querschnittsthema sieht die zuständige Fachstelle alle betroffenen Projekte, aus welcher Direktion sie auch kommen. Doppelspurigkeiten werden früh sichtbar, Kapazitäten lassen sich planen. Vor dem Speichern zeigt die CAF Suite, wer Einblick erhält.",
            "needToKnowLabel": "Need-to-know:",
            "needToKnowDesc": "Jede Einheit besitzt ihre Daten. Andere sehen nur, was ausdrücklich freigegeben ist – durchgesetzt auf dem Server, nicht nur in der Oberfläche.",
            "growLabel": "Klein beginnen, später wachsen:",
            "growDesc": "Eine Direktion kann allein starten und später Teil der Gesamtorganisation werden, ohne dass Daten verloren gehen."
        },
        "emailPlaceholder": "name@organisation.ch",
        "passwordRequired": "Passwort ist erforderlich",
        "linkingWrongPassword": "Falsches Passwort. Bitte versuchen Sie es erneut.",
        "linkingTooManyRequests": "Zu viele Versuche. Ihr Konto wurde temporär gesperrt. Bitte setzen Sie Ihr Passwort zurück.",
        "linkingFailed": "Fehler bei der Kontoverknüpfung.",
        "mfaNoSupportedFactor": "Kein unterstützter zweiter Faktor gefunden.",
        "linkingAccountExists": "Sie versuchen sich das erste Mal mit SSO anzumelden, aber Ihre E-Mail-Adresse <strong>{{email}}</strong> ist bereits mit einem Passwort-Konto registriert.",
        "linkingEnterOldPassword": "Bitte geben Sie <strong>ein letztes Mal Ihr altes Passwort</strong> ein, um die beiden Anmeldemethoden sicher zu verknüpfen. Danach können Sie sich bequem per SSO anmelden.",
        "authErrors": {
            "invalidCredentials": "Anmeldung fehlgeschlagen. Bitte überprüfen Sie E-Mail und Passwort.",
            "tooManyRequests": "Zu viele Versuche. Das Konto wurde vorübergehend gesperrt. Bitte versuchen Sie es später erneut.",
            "network": "Verbindungsfehler. Bitte prüfen Sie Ihre Internetverbindung.",
            "unexpected": "Ein unerwarteter Fehler ist aufgetreten.",
            "invalidEmail": "Ungültiges E-Mail-Format.",
            "resetFailed": "Die E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es später erneut."
        },
        "oeffentlicheVerwaltung": "öffentliche Verwaltung:",
        "introText": "Die CAF Suite verbindet die CAF-Selbstbewertung mit der Steuerung Ihrer Projekte – vom Amt über die Direktion bis zur Gesamtorganisation. Jede Einheit arbeitet eigenständig. Die übergeordnete Ebene sieht verdichtete Ergebnisse und die Projekte, die für sie von Bedeutung sind. Fachstellen wie die Informatik behalten ihre Querschnittsthemen über alle Direktionen hinweg im Blick.",
        "managementIntro": "Im intensiven Tagesgeschäft der öffentlichen Verwaltung ist es oft schwer, den strategischen Fokus zu behalten. Die CAF Suite gibt dem Management die Sicherheit, die Organisation professionell weiterzuentwickeln. Sie können jederzeit datengestützt darlegen, warum welche Prioritäten gesetzt wurden und wie der aktuelle Umsetzungsstand aussieht.",
        "managementQuote": "«Besser auf wenige, richtige Vorhaben fokussieren – und diese dann auch erfolgreich auf die Strasse bringen.»",
        "pillar1Desc": "Nutzen Sie das bewährte europäische CAF-Modell für strukturierte Selbst- und Fremdbewertungen. Statt auf subjektive Einschätzungen stützen Sie sich auf belastbare Daten, um die Stärken und Verbesserungspotenziale Ihrer Organisation präzise zu identifizieren – in jeder Einheit und verdichtet für die übergeordnete Ebene.",
        "pillar2Desc": "Nicht alles kann gleichzeitig erledigt werden. Unser Priorisierungstool hilft Ihnen und Ihrem Team, identifizierte Potenziale nach Relevanz und Dringlichkeit zu ordnen. So treffen Sie fundierte Ressourcen- und Budgetentscheidungen und legen den Fokus genau dorthin, wo er die grösste Wirkung erzielt.",
        "pillar3Title": "Strategien realisieren: Portfolio- & Projektmanagement",
        "pillar3Desc": "Verwandeln Sie Potenziale in messbare Erfolge. Das integrierte Projektportfolio zeigt jeder Ebene die Vorhaben, die sie steuern muss – von der eigenen Einheit bis zur Gesamtorganisation. Steuern Sie Projekte mit detaillierten Roadmaps, Matrix-Ansichten und Puls-Checks (Ampeln für Termine, Kosten, Ressourcen und Qualität). Das integrierte Task- und Board-Management sorgt dafür, dass Aufgaben kontrolliert im Team bearbeitet und Fristen eingehalten werden.",
        "pillar4Title": "Know-how aufbauen: Der Lern-Hub & Methodenbaukasten",
        "pillar4Desc": "Befähigen Sie Ihre Mitarbeitenden: Der integrierte Lern-Hub bietet schnellen Zugang zu bewährten Methoden für jedes einzelne CAF-Kriterium. Ob 360-Grad-Feedback, agile Führungskreise oder Balanced Scorecard – der Methodenbaukasten liefert das nötige Fachwissen direkt dort, wo es gebraucht wird.",
        "sicherheitUndDatenschutz": "Sicherheit & Datenschutz",
        "securityIntro": "Höchste Standards für Behörden. Unsere Infrastruktur ist auf Schutz, Souveränität und Compliance ausgelegt – so können Sie sich ganz auf die Organisationsentwicklung konzentrieren.",
        "iacAudit": "Infrastructure as Code (IaC) – vollständig auditierbar",
        "isdsDesc": "Wir liefern eine umfassende ISDS-Konzept-Vorlage mit allen wesentlichen Inhalten – das entlastet Ihre Projektleitung erheblich beim Onboarding.",
        "kontenVerknuepfenBtn": "Konten verknüpfen",
        "sso": {
            "lookupAppCheck": "Die Sicherheitsprüfung des Browsers ist noch nicht abgeschlossen, darum liess sich die Anmeldung über Ihre Organisation (SSO) nicht prüfen. Bitte versuchen Sie es in einigen Sekunden nochmals oder laden Sie die Seite neu.",
            "lookupFailed": "Die Anmeldung über Ihre Organisation (SSO) liess sich nicht prüfen. Bitte versuchen Sie es nochmals.",
            "linkPrepareFailed": "Das Konto existiert bereits, aber die Verknüpfung konnte nicht vorbereitet werden.",
            "popupClosed": "Das Anmeldefenster wurde geschlossen.",
            "popupBlocked": "Das Anmeldefenster wurde vom Browser blockiert. Bitte erlauben Sie Pop-ups für diese Seite.",
            "orgLoginButton": "Mit Organisation anmelden (SSO)",
            "domainDetected": "Ihre Organisation ({{tenantName}}) nutzt Single Sign-On.",
            "domainDetectedHint": "Klicken Sie auf 'Anmelden', um sich über Ihren Organisations-Account anzumelden.",
            "ssoError": "SSO-Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.",
            "ssoLoading": "SSO wird gestartet...",
            "checkingDomain": "Prüfe Organisation...",
            "fallbackHint": "Alternativ mit E-Mail und Passwort anmelden",
            "providerNotFound": "SSO-Provider nicht konfiguriert."
        },
        "passwortZuruecksetzen": "Passwort zurücksetzen",
        "willkommenZurueck": "Willkommen zurück",
        "wirSendenIhnenEinenLink": "Wir senden Ihnen einen Link per E-Mail.",
        "bitteMeldenSieSichAn": "Bitte melden Sie sich mit Ihrem Behörden-Konto an.",
        "verarbeite": "Verarbeite...",
        "linkAnfordern": "Link anfordern",
        "anmelden": "Anmelden",
        "funktionen": "Funktionen",
        "sicherheit": "Sicherheit",
        "kontakt": "Kontakt",
        "kontinuierlicheOrganisationsentwicklung": "Kontinuierliche Organisationsentwicklung",
        "exzellenzFuerDie": "Exzellenz für die",
        "heroSubline": "Von der Erkenntnis zur Umsetzung – über alle Ebenen.",
        "eMailVersendet": "E-Mail versendet!",
        "bittePruefenSieIhrenPosteingang": "Bitte prüfen Sie Ihren Posteingang für weitere Anweisungen.",
        "zurueckZumLogin": "Zurück zum Login",
        "eMailAdresse": "E-Mail Adresse",
        "passwort": "Passwort",
        "passwortVergessen": "Passwort vergessen?",
        "abbrechen": "Abbrechen",
        "tlsConnection": "Verschlüsselte Verbindung (TLS)",
        "souveraenFuehrenFundiertEntscheidenSicher": "Souverän führen. Fundiert entscheiden. Sicher umsetzen.",
        "die4SaeulenDerOrganisatorischen": "Die 4 Säulen der organisatorischen Weiterentwicklung",
        "evidenzStattBauchgefuehlDieDigitale": "Evidenz statt Bauchgefühl: Die digitale Bewertung",
        "fokusAufDasWesentlicheIntelligente": "Fokus auf das Wesentliche: Intelligente Priorisierung",
        "dieCafSuiteImEinsatz": "Die CAF Suite im Einsatz",
        "dataLocationTitle": "Fachdaten in der Schweiz",
        "dataLocationDesc": "Bewertungen, Projekte und Massnahmen werden in ISO-zertifizierten Rechenzentren der Google Cloud in Zürich gespeichert und verarbeitet. Die optionalen KI-Funktionen nutzen Rechenzentren in der EU.",
        "encryptionTitle": "Verschlüsselt übertragen und gespeichert",
        "encryptionDesc": "TLS-Verschlüsselung bei der Übertragung und AES-256-Verschlüsselung der gespeicherten Daten (Data at Rest).",
        "dataProtectionTitle": "Datenschutz nach DSG und DSGVO",
        "dataProtectionDesc": "Ausgelegt auf das Schweizer Datenschutzgesetz (DSG) und die EU-Datenschutz-Grundverordnung (DSGVO). Für Behörden bieten wir Auftragsverarbeitungsverträge (AVV) an.",
        "technischeStandards": "Technische Standards",
        "webApplicationFirewallWafMit": "Web Application Firewall (WAF) mit Cloud Armor",
        "wcagCompliance": "Barrierefreiheit nach WCAG 2.1 AA",
        "ciCdPipelineMitAutomatisierten": "CI/CD-Pipeline mit automatisierten Sicherheitschecks",
        "singleSignOnSsoVia": "Single Sign-On (SSO) via SAML 2.0 / OIDC / Microsoft Entra ID",
        "zweiFaktorAuthentifizierungTotp": "Zwei-Faktor-Authentifizierung (TOTP)",
        "taeglicheAutomatisierteBackups": "Tägliche automatisierte Backups",
        "auditLoggingRelevanterAenderungen": "Audit-Logging relevanter Änderungen",
        "isdsKonzept": "ISDS-Konzept:",
        "habenSieFragenOderWuenschen": "Haben Sie Fragen oder wünschen Sie eine Demo?",
        "contactTeaserText": "Wir zeigen Ihnen die CAF Suite gerne an einer Musterorganisation über drei Ebenen – vom Amt bis zum Kanton.",
        "kontaktAufnehmen": "Kontakt aufnehmen",
        "impressum": "Impressum",
        "datenschutz": "Datenschutz",
        "hilfe": "Hilfe",
        "privateDigital": "PRIVATE DIGITAL",
        "johannesSpring": "Johannes Spring",
        "voiaCumpogna1": "Voia Cumpogna 1",
        "schweiz": "Schweiz",
        "eMail": "E-Mail:",
        "haftungshinweisTrotzSorgfaeltigerInhaltlicherKontrolle": "Haftungshinweis: Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschliesslich deren Betreiber verantwortlich.",
        "wieErstelleIchEinenNeuen": "Wie erstelle ich einen neuen Benutzer?",
        "benutzerKoennenNurVonAdministratoren": "Benutzer können nur von Administratoren Ihrer Organisation eingeladen werden. Wenden Sie sich bitte an Ihre IT-Abteilung oder den CAF-Projektleiter Ihrer Behörde.",
        "technischerSupport": "Technischer Support",
        "beiTechnischenProblemenOderFehlermeldungen": "Bei technischen Problemen oder Fehlermeldungen helfen wir Ihnen gerne weiter.",
        "supportKontaktieren": "Support kontaktieren",
        "kontoVerknuepfen": "Konto verknüpfen",
        "ihreEMailAdresseExistiert": "Ihre E-Mail-Adresse existiert bereits.",
        "sieVersuchenSichDasErste": "Sie versuchen sich das erste Mal mit SSO anzumelden, aber Ihre E-Mail-Adresse",
        "bitteGebenSie": "Bitte geben Sie",
        "bisherigesPasswort": "Bisheriges Passwort",
        "verknuepfe": "Verknüpfe...",
        "datenschutzerklaerung": "Datenschutzerklärung",
        "hilfeSupport": "Hilfe & Support",
        "alleRechteVorbehalten": "© {{year}} PRIVATE DIGITAL Johannes Spring. Alle Rechte vorbehalten.",
        "hilfePasswortText": "Klicken Sie auf der Login-Seite auf \"Passwort vergessen\", um einen Link zum Zurücksetzen Ihres Passworts per E-Mail zu erhalten.",
        "carousel": {
            "portfolioSharing": "Weitergabe eines Projekts über die Ebenen",
            "topicRoadmap": "Road Map eines Querschnittsthemas",
            "assessmentAggregate": "Aggregat der unterstellten Einheiten",
            "portfolioChart": "Projektportfolio – Matrix-Ansicht",
            "portfolioTimeline": "Projektportfolio – Road Map",
            "selectProject": "Projektauswahl",
            "projectDetails": "Projektdetails",
            "tasks": "Task-Board (Kanban)",
            "myTasks": "Meine Aufgaben",
            "assessmentOverview": "Bewertungsübersicht",
            "assistent": "Bewertungs-Assistent",
            "criteria": "Modellinformationen",
            "methods": "Methodenbaukasten"
        }
    },
    "superAdmin": {
        "migration": {
            "loadingData": "Daten werden geladen...",
            "analyzingAssets": "Assets werden analysiert...",
            "packingAsset": "Asset {{current}}/{{total}} wird gepackt",
            "creatingZip": "ZIP-Datei wird erstellt...",
            "exportDone": "Export abgeschlossen. Gesicherte Assets: {{n}}.",
            "exportFailedAssets": "ACHTUNG: Einige Dateien konnten nicht geladen werden (Anzahl: {{n}}).\nGrund ist meist eine fehlende CORS-Konfiguration auf dem Storage-Bucket.\nDetails finden Sie in der Browser-Konsole.",
            "exportFailed": "Fehler beim Export: {{msg}}",
            "analyzingZip": "ZIP-Datei wird analysiert...",
            "zipMissingData": "Ungültiges ZIP: «data.json» fehlt.",
            "isZipFile": "Dies ist eine ZIP-Datei. Bitte als .zip importieren.",
            "noCafStructure": "Ungültige Daten: Keine CAF-Struktur gefunden.",
            "confirmImport": "Importieren? Dies überschreibt die globalen Einstellungen im System.",
            "assetsWillUpload": "Assets werden hochgeladen.",
            "importingAssets": "Assets werden importiert (fertig: {{n}})...",
            "missingInZip": "Fehlt im ZIP: {{file}}",
            "processingData": "Daten werden verarbeitet (dies kann einen Moment dauern)...",
            "importWarnings": "Import mit Warnungen abgeschlossen.\n\nÜbernommene Assets: {{ok}}\nFehlgeschlagen: {{failed}}",
            "importDoneAssets": "Import erfolgreich. Übernommene Assets: {{n}}.",
            "savingDatabase": "Datenbank wird gespeichert...",
            "importDone": "Daten erfolgreich importiert. Bitte laden Sie die Seite neu.",
            "importFailed": "Import fehlgeschlagen: {{msg}}"
        },
        "tenantCreatedSuccess": "Mandant «{{orgName}}» wurde angelegt. Der Tenant Admin erhält eine Einladung per E-Mail.",
        "title": "Mandantenverwaltung",
        "intro": "Verwalten Sie alle Organisationen, ihre Lizenzierung und Zugriffe.",
        "createTenant": "Neuen Mandanten anlegen",
        "tenantName": "Name der Organisation",
        "adminEmail": "Admin E-Mail",
        "status": "Status",
        "plan": "Plan",
        "actions": "Aktionen",
        "active": "Aktiv",
        "inactive": "Inaktiv",
        "created": "Erstellt am",
        "modalTitle": "Neuen Mandanten erstellen",
        "toggleStatus": "Status ändern",
        "createTenantTitle": "Neuen Mandanten anlegen",
        "createUserTitle": "Benutzer einladen",
        "editUserRoleTitle": "Rolle ändern",
        "deleteTenantTitle": "Mandanten löschen",
        "deleteTenantMessage": "Sind Sie sicher? Diese Aktion löscht den Mandanten und ALLE zugehörigen Daten unwiderruflich.",
        "deleteTenantConfirmationLabel": "Geben Sie zur Bestätigung den Namen der Organisation ein:",
        "deleteAssessorTitle": "Assessor löschen",
        "deleteAssessorMessage": "Sind Sie sicher? Diese Aktion löscht das Assessor-Konto unwiderruflich.",
        "deleteAssessorConfirmationLabel": "Geben Sie zur Bestätigung die E-Mail-Adresse ein:",
        "importExport": "Daten importieren / Exportieren",
        "exportGlobal": "Globalen Datenbestand exportieren (inkl. Assets)",
        "importGlobal": "Backup wiederherstellen",
        "importWarning": "Achtung: Überschreibt aktuelle Daten!",
        "fullDelete": "Vollständiges Löschen",
        "tenantDeleteButton": "Mandant vollständig löschen",
        "assessorDeleteButton": "Assessor vollständig löschen",
        "sso": {
            "title": "Single Sign-On (SAML 2.0)",
            "description": "Konfigurieren Sie SSO mit Microsoft Entra ID / Azure AD für diesen Mandanten.",
            "enabled": "SSO aktiviert",
            "disabled": "SSO deaktiviert",
            "enableToggle": "SAML SSO aktivieren",
            "displayName": "Anzeigename",
            "displayNamePlaceholder": "z.B. Stadt Bern SSO",
            "entityId": "IdP Entity ID",
            "entityIdPlaceholder": "z.B. https://sts.windows.net/{tenant-id}/",
            "ssoUrl": "SSO Login URL",
            "ssoUrlPlaceholder": "https://login.microsoftonline.com/{tenant-id}/saml2",
            "certificate": "X.509 Zertifikat (PEM)",
            "certificatePlaceholder": "-----BEGIN CERTIFICATE-----\\n...\\n-----END CERTIFICATE-----",
            "domains": "SSO Domains",
            "domainsPlaceholder": "stadt-bern.ch, gemeinde-thun.ch",
            "domainsHint": "Kommagetrennte E-Mail-Domains, die via SSO angemeldet werden.",
            "save": "SSO konfigurieren",
            "saving": "Speichere...",
            "remove": "SSO entfernen",
            "removing": "Entferne...",
            "configured": "SSO konfiguriert",
            "notConfigured": "SSO nicht konfiguriert",
            "saveSuccess": "SSO-Konfiguration erfolgreich gespeichert.",
            "removeSuccess": "SSO-Konfiguration entfernt.",
            "removeConfirm": "SSO für diesen Mandanten wirklich deaktivieren? Benutzer müssen sich danach mit E-Mail/Passwort anmelden.",
            "rpEntityId": "SP Entity ID (optional)",
            "rpEntityIdPlaceholder": "Leer lassen für Auto-Generierung"
        },
        "assessorDeleted": "Assessor \"{{email}}\" wurde unwiderruflich gelöscht.",
        "errorChangeStatus": "Fehler beim Ändern des Assessor Status.",
        "orgSummary": "Organisation",
        "orgSummaryValue": "{{units}} Einheiten · {{levels}} Ebenen",
        "events": {
            "title": "Änderungen in Mandanten ({{count}})",
            "intro": "Tenant Admins können ihre Struktur selbst erweitern und ihren Mandanten umbenennen. Prüfen Sie, ob Vertrag und Verrechnung angepasst werden müssen, und quittieren Sie die Meldung.",
            "acknowledge": "Zur Kenntnis genommen",
            "loadError": "Meldungen konnten nicht geladen werden.",
            "ackError": "Quittieren fehlgeschlagen."
        }
    },
    "modals": {
        "ok": "OK",
        "close": "Schliessen",
        "save": "Speichern",
        "cancel": "Abbrechen",
        "apply": "Übernehmen",
        "confirmDelete": "Löschen bestätigen",
        "confirmReset": "Zurücksetzen bestätigen",
        "resetScoresTitle": "Punkte zurücksetzen",
        "resetScoresMessage": "Möchten Sie wirklich alle vergebenen Punkte in dieser Bewertung entfernen? Ihre Texte (Stärken/Verbesserungspotenziale) bleiben erhalten.",
        "assessmentInfoTitle": "CAF Bewertungsmethodik",
        "criterionInfoTitle": "Kriteriumsdetails",
        "enablerScoringTitle": "Bewertung der Befähiger",
        "enablerScoringIntro": "Die Bewertung erfolgt nach dem PDCA-Zyklus (Plan-Do-Check-Act). Bewerten Sie den Reifegrad der Umsetzung:",
        "enablerScoringDetails": {
            "plan": "<strong>PLAN (0-30 Punkte):</strong> Planungsphase. Es gibt Ansätze oder Ideen, aber noch keine systematische Umsetzung.",
            "do": "<strong>DO (31-50 Punkte):</strong> Umsetzung. Die Ansätze werden in relevanten Bereichen angewendet.",
            "check": "<strong>CHECK (51-70 Punkte):</strong> Überprüfung. Die Wirksamkeit der Umsetzung wird regelmässig gemessen und überprüft.",
            "act": "<strong>ACT (71-90 Punkte):</strong> Verbesserung. Basierend auf den Überprüfungen werden Korrekturmassnahmen eingeleitet und Prozesse optimiert.",
            "excellent": "<strong>EXCELLENCE (91-100 Punkte):</strong> Der Ansatz ist Vorbildcharakter (Benchmark) und wird kontinuierlich verbessert."
        },
        "resultScoringTitle": "Bewertung der Ergebnisse",
        "resultScoringIntro": "Hier wird bewertet, welche Resultate die Organisation erzielt hat. Achten Sie besonders auf Trends über die letzten 3 Jahre:",
        "resultScoringDetails": {
            "none": "<strong>0-10 Punkte:</strong> Keine Ergebnisse gemessen oder verfügbar.",
            "negative": "<strong>11-30 Punkte):</strong> Ergebnisse sind vorhanden, zeigen aber negative Trends oder erreichen die Ziele nicht.",
            "stable": "<strong>31-50 Punkte):</strong> Ergebnisse sind stabil oder zeigen leichte Verbesserungen.",
            "positive": "<strong>51-70 Punkte):</strong> Ergebnisse zeigen einen klaren positiven Trend über mehrere Jahre.",
            "targets": "<strong>71-90 Punkte):</strong> Relevante Ziele werden erreicht oder übertroffen. Positive Vergleiche mit anderen Organisationen.",
            "excellent": "<strong>91-100 Punkte):</strong> Dauerhaft herausragende Ergebnisse und Spitzenposition im Vergleich."
        },
        "editAction": "Massnahme bearbeiten",
        "addAction": "Neue Massnahme erfassen",
        "title": "Titel",
        "description": "Beschreibung",
        "relatedSubCriterion": "Zugehöriges CAF-Kriterium",
        "selectSubCriterion": "Wählen Sie ein Kriterium",
        "responsiblePerson": "Verantwortliche Person",
        "selectResponsible": "Person auswählen...",
        "noResponsible": "Kein Verantwortlicher zugewiesen",
        "dueDate": "Fälligkeitsdatum",
        "reminderDate": "Erinnerungstermin",
        "reminderHint": "Auto: 14 Tage vor Fälligkeit (min. Heute)",
        "status": "Status",
        "deleteActionTitle": "Massnahme löschen",
        "deleteActionMessage": "Sind Sie sicher, dass Sie diese Massnahme löschen möchten?",
        "deleteAssessmentTitle": "Bewertung löschen",
        "deleteAssessmentMessage": "Sind Sie sicher, dass Sie die Bewertung vom <strong>{{date}}</strong> löschen möchten?",
        "deleteCriterionTitle": "Themenfeld löschen",
        "deleteCriterionMessage": "Sind Sie sicher, dass Sie das Themenfeld \"<strong>{{title}}</strong>\" löschen möchten?",
        "deleteCriterionWarning": "Dadurch werden auch alle zugehörigen Kriterien und deren Bewertungsdaten dauerhaft gelöscht.",
        "deleteSubCriterionTitle": "Kriterium löschen",
        "deleteSubCriterionMessage": "Sind Sie sicher, dass Sie das Kriterium \"<strong>{{title}}</strong>\" löschen möchten?",
        "deleteSubCriterionWarning": "Dadurch werden auch alle zugehörigen Bewertungsdaten dauerhaft gelöscht.",
        "deleteBestPracticeMessage": "Möchten Sie dieses Beispiel wirklich löschen?",
        "editUserTitle": "Benutzer bearbeiten",
        "editProfileTitle": "Profil bearbeiten",
        "editUserMessage": "Bearbeiten Sie die Details des Benutzers.",
        "createMeasure": {
            "title": "Projektauswahl",
            "forPotential": "für Potenzial:",
            "done": "Fertig",
            "manual": "Projekt selbst formulieren",
            "aiSuggestions": "KI-Vorschläge",
            "generateAi": "KI-Vorschläge generieren",
            "analyzing": "Analysiere Potenzial & Kriterium...",
            "relevantMethods": "Methoden zum Kriterium",
            "noMethods": "Keine spezifischen Methoden für dieses Kriterium gefunden.",
            "adoptMethod": "Projekt erstellen",
            "methodLabel": "Methode"
        },
        "edit": "Bearbeiten",
        "delete": "Löschen"
    },
    "common": {
        "serviceUnavailable": "Der Dienst ist momentan nicht erreichbar. Bitte versuchen Sie es später erneut.",
        "remove": "Entfernen",
        "open": "Öffnen",
        "ai": {
            "suggestionLabel": "KI-Vorschlag",
            "backToOverview": "Zurück zur Übersicht",
            "adoptSuggestion": "Projekt erstellen",
            "generateTitleTooltip": "Titel basierend auf Beschreibung generieren"
        },
        "sessionWarning": {
            "title": "Ihre Sitzung läuft bald ab",
            "message_one": "Aus Sicherheitsgründen werden Sie in 1 Minute automatisch abgemeldet. Möchten Sie angemeldet bleiben?",
            "message_other": "Aus Sicherheitsgründen werden Sie in {{minutes}} Minuten automatisch abgemeldet. Möchten Sie angemeldet bleiben?",
            "extendButton": "Angemeldet bleiben",
            "logoutButton": "Jetzt abmelden"
        },
        "notAvailable": "N/V",
        "assessmentSaved": "Bewertung erfolgreich gespeichert!",
        "actionCreated": "Massnahme erstellt!",
        "actionUpdated": "Massnahme aktualisiert!",
        "noAssessmentSelected": "Keine Bewertung zum Speichern ausgewählt.",
        "saving": "Speichern...",
        "processing": "Verarbeite...",
        "allChangesSaved": "Alle Änderungen gespeichert",
        "verify": "Überprüfen",
        "cancel": "Abbrechen",
        "viewDetails": "Details ansehen",
        "description": "Beschreibung",
        "success": "Erfolg",
        "offlineWarningTitle": "Keine Internetverbindung",
        "offlineWarningMessage": "Sie sind aktuell offline. Bitte stellen Sie die Internetverbindung wieder her und versuchen Sie es erneut. Ihre Eingaben gehen nicht verloren.",
        "offlineMoveTaskWarning": "Massnahmen können ohne Internetverbindung nicht verschoben werden. Bitte stellen Sie die Internetverbindung wieder her.",
        "errors": {
            "pdfGeneration": "Fehler beim Erstellen des PDFs.",
            "cleanup": "Fehler beim Bereinigen.",
            "save": "Fehler beim Speichern: {{msg}}",
            "delete": "Fehler beim Löschen.",
            "archiveTasks": "Fehler beim Archivieren der Massnahmen.",
            "saveTask": "Fehler beim Speichern der Aufgabe.",
            "saveVote": "Fehler beim Speichern der Stimme: {{msg}}",
            "saveProject": "Fehler beim Speichern des Projekts: {{msg}}",
            "linkProject": "Fehler beim Verknüpfen des Projekts: {{msg}}",
            "pdfExport": "Fehler beim Exportieren des PDFs.",
            "publish": "Fehler bei der Freigabe.",
            "updateStatus": "Fehler beim Aktualisieren des Status.",
            "functionsUnavailable": "Fehler: Die Verbindung zu den Cloud Functions ist nicht verfügbar.",
            "functionsUnavailableShort": "Cloud Functions nicht verfügbar.",
            "changeRole": "Fehler: {{msg}}",
            "createLabel": "Fehler beim Erstellen des Labels.",
            "moveTask": "Fehler beim Verschieben der Aufgabe.",
            "saveTaskMsg": "Fehler beim Speichern der Aufgabe: {{msg}}",
            "sendComment": "Fehler beim Senden des Kommentars",
            "backendMissing": "Fehler: Backend-Verbindung fehlt.",
            "deleteUser": "Fehler beim Löschen des Benutzers.",
            "generic": "Ein Fehler ist aufgetreten",
            "deleteMsg": "Fehler beim Löschen: {{msg}}"
        },
        "linkCopied": "Link kopiert!",
        "sending": "Sende...",
        "selectedCount": "{{count}} ausgewählt",
        "saveChanges": "Änderungen speichern",
        "send": "Senden",
        "view": "Anzeigen",
        "unknownError": "Unbekannter Fehler",
        "unknownTenant": "Unbekannter Mandant",
        "unknownLabel": "Unbekanntes Label",
        "unknownCategory": "Unbekannte Kategorie",
        "unknownDate": "Unbekannt",
        "ourOrganization": "Unsere Organisation",
        "recordedOn": "Erfasst am {{date}} von {{name}}",
        "openMenu": "Menü öffnen",
        "clearSearch": "Suche zurücksetzen",
        "toggleDetails": "Details umschalten",
        "mainContent": "Hauptinhalt",
        "sidebarNavigation": "Seitennavigation",
        "mainNavigation": "Hauptnavigation",
        "skipToContent": "Zum Inhalt springen",
        "landmarkNavHint": "Mit F6 zwischen Navigation und Inhalt wechseln",
        "close": "Schliessen",
        "save": "Speichern",
        "collapse": "Einklappen",
        "expand": "Ausklappen",
        "edit": "Bearbeiten",
        "delete": "Löschen",
        "error": "Fehler",
        "retry": "Erneut versuchen",
        "back": "Zurück",
        "moveUp": "Nach oben verschieben",
        "moveDown": "Nach unten verschieben",
        "errorOccurred": "Ein Fehler ist aufgetreten.",
        "next": "Weiter",
        "loading": "Laden..."
    },
    "userManagement": {
        "displayName": "Anzeigename",
        "title": "Benutzerverwaltung",
        "subtitle": "Verwalten Sie Benutzerzugriffe und externe Assessoren für Ihre Organisation.",
        "tabs": {
            "internal": "Mitarbeiter",
            "external": "Externe Assessoren"
        },
        "titles": {
            "registered": "Registrierte Benutzer",
            "associated": "Zugeordnete Assessoren"
        },
        "buttons": {
            "inviteUser": "Benutzer einladen",
            "addAssessor": "Assessor hinzufügen",
            "invite": "Einladen",
            "sending": "Sende...",
            "adding": "Füge hinzu...",
            "add": "Hinzufügen",
            "cancel": "Abbrechen",
            "edit": "Bearbeiten",
            "remove": "Entfernen",
            "save": "Speichern",
            "saving": "Speichert..."
        },
        "labels": {
            "email": "E-Mail Adresse",
            "assessorEmail": "E-Mail Adresse des Assessors",
            "permissionLevel": "Berechtigungs-Level",
            "changeLevelPrefix": "Level",
            "changeLevelSuffix": "ändern...",
            "selectLevelSuffix": "auswählen...",
            "emailLanguage": "Sprache der Einladung",
            "orgUnit": "Organisationseinheit"
        },
        "placeholders": {
            "email": "mitarbeiter@amt.ch",
            "assessorEmail": "assessor@externe-firma.ch",
            "name": "Max Mustermann",
            "selectOrgUnit": "Hauptorganisation (Mandantenweit)",
            "chooseOrgUnit": "Einheit wählen"
        },
        "filters": {
            "allOrgUnits": "Alle Organisationseinheiten",
            "filterByOrgUnit": "Nach Organisationseinheit filtern"
        },
        "badges": {
            "tenantAdmin": "Tenant-Admin",
            "mainOrg": "Hauptorganisation",
            "tenantWide": "Mandantenweit",
            "orgAdmin": "Org-Admin",
            "noOrgUnit": "Keine Einheit"
        },
        "hints": {
            "isOrgAdmin": "Erlaubt diesem Benutzer, Kollegen innerhalb der gewählten Organisationseinheit einzuladen und zu verwalten.",
            "isOrgAdminFixed": "Sie laden diesen Benutzer als Mitglied Ihrer Organisationseinheit ein."
        },
        "table": {
            "nameEmail": "Name / E-Mail",
            "orgUnit": "Organisationseinheit",
            "roleStatus": "Rolle / Status",
            "actions": "Aktionen",
            "noUsers": "Keine Benutzer gefunden.",
            "noAssessors": "Keine externen Assessoren zugeordnet.",
            "caption": "Benutzerliste"
        },
        "roles": {
            "externalAssessor": "Externer Assessor",
            "external": "Extern"
        },
        "modals": {
            "editUserTitle": "Benutzer bearbeiten",
            "userUpper": "BENUTZER",
            "noName": "Kein Name",
            "inviteSuccessTitle": "Benutzer eingeladen",
            "addSuccessTitle": "Erfolgreich hinzugefügt",
            "emailSent": "E-Mail erfolgreich versendet!",
            "activationInfo": "Der Benutzer erhält einen Link, um sein Passwort festzulegen und den Account zu aktivieren.",
            "emailFailed": "Konto erstellt, aber E-Mail fehlgeschlagen.",
            "emailFailedHint": "Der Benutzer wurde im System angelegt, aber wir konnten keine E-Mail senden. Bitte bitten Sie den Benutzer, beim Login auf \"Passwort vergessen\" zu klicken.",
            "removeAssessorTitle": "Assessor entfernen",
            "revokeAccessTitle": "Zugriff entziehen",
            "removeAssessorConfirm": "Möchten Sie den Assessor {{email}} aus diesem Mandanten entfernen?",
            "revokeAccessConfirm": "Möchten Sie dem Benutzer {{email}} den Zugriff auf diese Organisation entfernen?",
            "checkingDependencies": "Prüfe auf zugewiesene Projekte und Massnahmen...",
            "orphanedWarningTitle": "Achtung: Verwaiste Einträge!",
            "orphanedWarningDetail": "Dieser Benutzer ist noch immer zugewiesen zu:",
            "projectsCount": "{{count}} Projekt(en) als Projektleitung",
            "tasksCount": "{{count}} Massnahme(n) als verantwortliche Person",
            "orphanedConsequence": "Wenn Sie diesen Benutzer löschen, bleiben diese Einträge ohne gültige Verantwortlichkeit zurück.",
            "removeAssessorNote": "Der Assessor verliert den Zugriff auf diesen Mandanten. Seine anderen Mandanten sind nicht betroffen.",
            "revokeAccessNote": "Das Profil wird gelöscht und der Login deaktiviert.",
            "userExistsDetail": "ist bereits im System registriert.",
            "userExistsTip": "Wenn es sich um einen Assessor handelt, versuchen Sie es bitte über den Tab \"Externe Assessoren\".",
            "notFoundDetail": "finden.",
            "assessorRegisterHint": "Der Assessor muss sich zuerst selbst im System registrieren (\"Als Assessor registrieren\" auf der Login-Seite), bevor er einem Mandanten hinzugefügt werden kann."
        },
        "validation": {
            "invalidEmail": "Ungültige E-Mail-Adresse",
            "nameRequired": "Name ist erforderlich",
            "orgUnitRequired": "Organisationseinheit erforderlich"
        },
        "errors": {
            "permissionDenied": "Zugriff verweigert.",
            "loadFailed": "Fehler beim Laden der Benutzer.",
            "inviteFailed": "Fehler beim Einladen",
            "addFailed": "Fehler beim Hinzufügen",
            "assessorInactive": "Dieser Assessor Account ist inaktiviert und kann nicht hinzugefügt werden.",
            "notAnAssessor": "Diese E-Mail gehört zu einem existierenden Benutzer, der KEIN Assessor ist.",
            "assessorAlreadyAdded": "Dieser Assessor ist bereits hinzugefügt.",
            "cannotChangeRole": "Konnte Rolle nicht ändern.",
            "deleteFailed": "Löschen fehlgeschlagen."
        },
        "messages": {
            "assessorInvited": "Eine Einladungs-E-Mail wurde gesendet. Der Assessor kann seine Registrierung nun abschliessen und hat anschliessend Zugriff.",
            "assessorAlreadyAdded": "Dieser Assessor ist bereits zugeordnet.",
            "assessorAdded": "Der Assessor wurde erfolgreich hinzugefügt und kann nun Bewertungen für diesen Mandanten einreichen."
        },
        "noRoles": "Keine Fachrolle"
    },
    "settings": {
        "projectSpecificTitle": "Einstellungen einzelner Projekte",
        "projectSpecificHint": "Projektmitglieder, Labels und projektspezifische Felder für Massnahmen legen Sie im jeweiligen Projekt über das Zahnrad oben rechts fest. Das können die Projektleitung und das Portfoliomanagement der Einheit, in der das Projekt entstanden ist. Übergeordnete Einheiten sehen weitergegebene Projekte nur lesend.",
        "toggleSr": "Ein/Aus",
        "ok": "OK",
        "introUnit": "Kategorien Ihrer Einheit für das Projektportfolio.",
        "title": "Einstellungen",
        "intro": "Verwalten Sie globale Konfigurationen für Ihre Organisation.",
        "mfaTitle": "2-Faktor-Authentifizierung (MFA)",
        "mfaToggleLabel": "Mehrfaktorauthentifizierung (MFA) für alle Benutzer erzwingen",
        "mfaDescription": "Wenn aktiviert, müssen alle Benutzer dieser Organisation eine Authenticator-App (TOTP) einrichten, bevor sie die CAF Suite weiter nutzen können.",
        "mfaSsoExemptNote": "SSO-Benutzer sind von der MFA-Pflicht ausgenommen, da die Identitätsprüfung über den SSO-Provider (z. B. Microsoft Entra ID) erfolgt.",
        "mfaDialog": {
            "setupOwnFirst": { "title": "Zuerst Ihr eigenes Konto schützen", "message": "Bevor Sie MFA für alle erzwingen, richten Sie eine Authenticator-App für Ihr eigenes Konto ein. So können Sie sich nicht aussperren. Danach schalten Sie die Pflicht hier ein.", "confirm": "MFA jetzt einrichten" },
            "enable": { "title": "MFA für alle erzwingen?", "message": "Wer noch keine Authenticator-App eingerichtet hat, wird sofort zur Einrichtung geführt und kann die CAF Suite erst danach wieder nutzen.", "confirm": "MFA erzwingen" },
            "disable": { "title": "MFA-Pflicht aufheben?", "message": "Danach ist der zweite Faktor freiwillig. Bereits eingerichtete Authenticator-Apps bleiben aktiv.", "confirm": "Pflicht aufheben" }
        },
        "analysisTitle": "Künstliche Intelligenz",
        "analysisToggleLabel": "KI-Funktionen aktivieren",
        "analysisDescription": "Wenn aktiviert, können die User KI-Funktionen nutzen (z.B. Generierung von Projektideen oder KI-basierte Erstellung von Berichten).",
        "prioritizationTitle": "Priorisierungs-Modul",
        "prioritizationToggleLabel": "Priorisierung der Potenziale aktivieren",
        "prioritizationDescription": "Aktiviert ein Modul zwischen Bewertung und Massnahmenplan, um Potenziale durch Team-Voting und Dringlichkeit vorzuselektieren.",
        "warningTitle": "Wichtiger Hinweis zum Datenschutz",
        "warningText": "Für die Analyse werden anonymisierte Bewertungsdaten, Bemerkungen (Stärken/Potenziale) und Massnahmentitel an die Google Gemini API gesendet. Es werden keine User- oder Personendaten übermittelt. Deaktivieren Sie diese Funktion, wenn Ihre Organisation die Nutzung von Cloud-basierten KI-Diensten für diese Art von Daten nicht gestattet.",
        "saveTitle": "Projekteinstellungen speichern",
        "saveSuccess": "Einstellung gespeichert.",
        "saveError": "Fehler beim Speichern.",
        "dataExport": {
            "title": "Datenexport",
            "description": "Laden Sie alle Bewertungen, Projekte und Massnahmen Ihrer Organisation als JSON-Datei herunter.",
            "button": "Daten exportieren",
            "loading": "Export wird erstellt...",
            "success": "Export erfolgreich heruntergeladen.",
            "error": "Fehler beim Exportieren der Daten."
        },
        "promise": "Promise",
        "modulProjektmanagement": "Modul Projektmanagement",
        "achsenImPortfoliomanagementAendern": "Achsen im Portfoliomanagement ändern",
        "wechseltImBubbleChartIn": "Wechselt im Bubble-Chart in die alternative Ansicht (x: Strategischer Bezug, y: Geschätzter Aufwand, Bubble-Grösse: Nutzen).",
        "wipLimitsAktivieren": "WIP-Limits aktivieren",
        "wipLimitsDescription": "Kontrolliert die Anzahl gleichzeitiger Projekte in der \"In Umsetzung\"-Phase im Portfolio-Kanban anhand von definierten Kapazitäts-Töpfen (Buckets).",
        "kapazitaetsToepfeBucketsKonfiguration": "Kapazitäts-Töpfe (Buckets) Konfiguration",
        "keineBucketsDefiniertBitteVorlage": "Keine Buckets definiert. Bitte Vorlage anpassen.",
        "bucketName": "Bucket Name",
        "bucketNamePlaceholder": "z.B. Grossprojekte",
        "addBucket": "Bucket hinzufügen",
        "projektgroessenTShirt": "Projektgrössen (T-Shirt)",
        "wipLimit": "WIP-Limit",
        "projektrisikenAktivieren": "Projektrisiken aktivieren",
        "aktiviertDasModulProjektrisikenUm": "Aktiviert das Modul Projektrisiken, um projektbezogene Risiken mit Schadenausmass und Wahrscheinlichkeit zu erfassen.",
        "taskManagementAktivieren": "Task Management aktivieren",
        "aktiviertDasModulTaskManagement": "Aktiviert das Modul Task Management, um pro Projekt Tasks flexibel in Listen, als Board oder auf einer Timeline als Nachfolge des alten Massnahmenplans zu verwalten.",
        "modulBewertung": "Modul Bewertung",
        "modulAdministration": "Modul Administration",
        "inhaltsverwaltungAktivieren": "Inhaltsverwaltung aktivieren",
        "contentManagementDescription": "Aktiviert das Modul \"Inhaltsverwaltung\" für Administratoren, um eigene Themenbereiche, Kriterien und/oder Beispiele zu den offiziellen CAF-Kriterien zu ergänzen.",
        "availableLanguages": "Verfügbare Sprachen",
        "availableLanguagesDescription": "Definieren Sie, welche Sprachen den Benutzern dieses Mandanten in ihrem Profil zur Auswahl stehen.",
        "loeschen": "Löschen"},
    "app": {
        "globalTemplatesTitle": "Globale Vorlagen verwalten",
        "globalTemplatesIntro": "Hier definieren Sie die Standard-Struktur (Kriterien & Best Practices) sowie Informationsbereiche für alle Mandanten.",
        "connection": {
            "connectingTitle": "Verbindung wird hergestellt …",
            "connectingMessage": "Die Verbindung ist langsam. Bitte einen Moment Geduld.",
            "failedTitle": "Verbindung fehlgeschlagen",
            "failedMessage": "Ihre Anmeldung ist in Ordnung, aber Ihre Daten konnten nicht geladen werden, meist wegen einer langsamen oder unterbrochenen Internetverbindung. Wir versuchen es automatisch weiter.",
            "retry": "Erneut versuchen",
            "retrying": "Wird versucht …"
        },
        "update": { "title": "Neue Version verfügbar", "description": "Eine aktualisierte Version der CAF Suite steht bereit. Bitte speichern Sie Ihre Arbeit und aktualisieren Sie die App.", "later": "Später", "now": "Jetzt aktualisieren" },
        "loading": "Laden...",
        "viewNotFound": "Ansicht nicht gefunden",
        "errors": {
            "noTenant": {
                "title": "Keine Organisation zugewiesen",
                "message": "Ihr Benutzerkonto ist keiner Organisation zugeordnet. Bitte kontaktieren Sie den Support."
            },
            "accountDisabled": {
                "title": "Account gesperrt / Inaktiv",
                "message": "Ihr Benutzerkonto wurde deaktiviert. Bitte kontaktieren Sie den Support oder Ihren Administrator für weitere Informationen.",
                "logout": "Abmelden"
            },
            "emailSendFailed": "Fehler beim Senden: {{msg}}",
            "emailSendUnknown": "Fehler beim Senden: Unbekannter Fehler"
        },
        "navigationGuard": {
            "title": "Ungespeicherte Änderungen",
            "message": "Sie haben Änderungen vorgenommen, die noch nicht gespeichert wurden.",
            "warning": "Möchten Sie die Seite wirklich verlassen? Alle ungespeicherten Änderungen gehen dabei verloren.",
            "confirmButton": "Trotzdem verlassen"
        },
        "verifyEmail": {
            "title": "E-Mail Bestätigung erforderlich",
            "prompt": "Bitte bestätigen Sie Ihre E-Mail-Adresse",
            "spamFolder": "um fortzufahren. Überprüfen Sie auch Ihren Spam-Ordner.",
            "confirmReload": "Ich habe bestätigt (Seite neu laden)",
            "successMessage": "E-Mail wurde erneut gesendet!",
            "resendLink": "Bestätigungs-Link erneut senden"
        },
        "projectSpecificTitle": "Einstellungen einzelner Projekte",
        "projectSpecificHint": "Projektmitglieder, Labels und projektspezifische Felder für Massnahmen legen Sie im jeweiligen Projekt über das Zahnrad oben rechts fest. Das können die Projektleitung und das Portfoliomanagement der Einheit, in der das Projekt entstanden ist. Übergeordnete Einheiten sehen weitergegebene Projekte nur lesend."
    },
    "contact": {
        "companyRequired": "Für Offerten und Demos ist die Organisation erforderlich",
        "title": "Kontakt aufnehmen",
        "topic": "Anliegen",
        "topics": {
            "general": "Allgemeine Anfrage",
            "quote": "Offerte anfragen",
            "demo": "Demo anfragen",
            "support": "Support"
        },
        "name": "Name",
        "email": "E-Mail",
        "organization": "Organisation",
        "phone": "Telefon (optional)",
        "subject": "Betreff",
        "subjectPlaceholders": {
            "quote": "Offertenanfrage für...",
            "demo": "Demo-Anfrage für...",
            "support": "Problem mit...",
            "general": ""
        },
        "message": "Nachricht",
        "send": "Nachricht senden",
        "sending": "Senden...",
        "successTitle": "Vielen Dank!",
        "successMessage": "Wir haben Ihre Nachricht erhalten und werden uns schnellstmöglich bei Ihnen melden.",
        "close": "Schliessen",
        "backendError": "Backend nicht verfügbar",
        "genericError": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut."
    },
    "errorBoundary": {
        "title": "Ein Fehler ist aufgetreten",
        "message": "Die Anwendung konnte nicht gestartet werden. Dies liegt meist an Netzwerkproblemen, fehlenden Berechtigungen oder einer veralteten Konfiguration.",
        "reload": "Seite neu laden"
    },
    "task": {
        "title": "Massnahmen (Tasks)",
        "open": "Offen",
        "inProgress": "In Arbeit",
        "review": "Review",
        "done": "Erledigt",
        "labels": "Labels",
        "effortEstimate": "Aufwand",
        "customFields": "Projektspezifische Felder"
    },
    "projectRisks": {
        "loadError": "Fehler beim Laden der Projektrisiken.",
        "matrixPosition": "Schaden: {{damage}}, Wahrscheinlichkeit: {{probability}}",
        "matrixCellTitle_one": "Schaden: {{damage}}, Wahrscheinlichkeit: {{probability}} ({{count}} Risiko)",
        "matrixCellTitle_other": "Schaden: {{damage}}, Wahrscheinlichkeit: {{probability}} ({{count}} Risiken)",
        "taskFromRiskTitle": "Massnahme zu Risiko: {{name}}",
        "title": "Projektrisiken",
        "description": "Verwalten Sie Risiken mit Schadenausmass und Eintrittswahrscheinlichkeit.",
        "addRisk": "Neues Risiko erfassen",
        "editRisk": "Risiko bearbeiten",
        "deleteRiskTitle": "Risiko löschen",
        "deleteRiskMessage": "Möchten Sie dieses Risiko wirklich löschen?",
        "name": "Risikoname",
        "riskDescription": "Risikobeschreibung (credible worst-case)",
        "damage": "Schadenausmass",
        "probability": "Eintrittswahrscheinlichkeit",
        "history": "Historie",
        "generateTask": "Massnahme generieren",
        "tasks": "Abgeleitete Massnahmen",
        "matrixTitle": "Risikomatrix",
        "listTitle": "Risikoliste",
        "noRisks": "Keine Risiken erfasst.",
        "save": "Speichern",
        "cancel": "Abbrechen",
        "highRisk": "Hohes Risiko",
        "damageOptions": {
            "1": "1 - Gering",
            "2": "2 - Spürbar",
            "3": "3 - Kritisch",
            "4": "4 - Katastrophal"
        },
        "probabilityOptions": {
            "1": "1 - Unwahrscheinlich",
            "2": "2 - Möglich",
            "3": "3 - Wahrscheinlich",
            "4": "4 - Fast sicher"
        },
        "noTasksYet": "Noch keine Massnahmen verknüpft.",
        "oneMeasure": "1 Massnahme",
        "measuresCount": "{{count}} Massnahmen",
        "damage1": "1 - Gering",
        "damage2": "2 - Spürbar",
        "damage3": "3 - Kritisch",
        "damage4": "4 - Katastrophal",
        "prob1": "1 - Unwahrscheinlich",
        "prob2": "2 - Möglich",
        "prob3": "3 - Wahrscheinlich",
        "prob4": "4 - Fast sicher"
    },
    "projectSettings": {
        "labelsLoadError": "Fehler beim Laden der Labels.",
        "deleteLabelError": "Fehler beim Löschen des Labels.",
        "tasksTab": "Massnahmen",
        "customFieldsTitle": "Projektspezifische Felder",
        "customFieldsDescription": "Definieren Sie bis zu 3 zusätzliche Felder für Massnahmen dieses Projekts.",
        "fieldLabel": "Feldname",
        "fieldType": "Feldtyp",
        "fieldTypeText": "Textfeld",
        "fieldTypeCheckbox": "Checkbox",
        "fieldTypeDropdown": "Dropdown",
        "dropdownOptions": "Auswahloptionen",
        "dropdownOptionsHint": "Kommagetrennt (z.B. Option A, Option B, Option C)",
        "addField": "+ Feld hinzufügen",
        "maxFieldsReached": "Maximal 3 Felder möglich.",
        "taskWipLimitTitle": "WIP-Limit (Massnahmen)",
        "taskWipLimitDescription": "Kontrolliert die Anzahl gleichzeitiger Massnahmen in der \"In Arbeit\"-Phase anhand von definierten Kapazitäts-Töpfen (Buckets).",
        "taskWipLimitLabel": "Maximale Anzahl",
        "taskWipLimitDisabled": "Kein Limit",
        "saveSettings": "Einstellungen speichern",
        "membersSaveError": "Fehler beim Speichern der Mitglieder.",
        "measuresSaveError": "Fehler beim Speichern der Massnahmen-Einstellungen.",
        "membersDescription": "Wählen Sie aus, wer auf dieses Projekt zugreifen und an Aufgaben mitarbeiten darf. Level-30-Benutzer und Administratoren haben ohnehin Zugriff auf alle Projekte.",
        "wipBucketsConfig": "Kapazitäts-Töpfe (Buckets) Konfiguration",
        "addBucket": "+ Bucket hinzufügen",
        "automZugriff": "Autom. Zugriff (Lvl {{level}})",
        "membersFooterHint": "Änderungen werden erst nach dem Speichern wirksam.",
        "tasksFooterHint": "Felder und WIP-Limits werden projektspezifisch gespeichert.",
        "labelsFooterHint": "Labels werden sofort erstellt und gelöscht.",
        "updateLabelError": "Fehler beim Aktualisieren des Labels.",
        "membersDescriptionV2": "Wählen Sie aus, wer auf dieses Projekt zugreifen und an Massnahmen mitarbeiten darf. Portfoliomanagement und Management der Herkunftseinheit haben ohnehin Zugriff.",
        "automZugriffPortfolio": "Autom. Zugriff (Portfolio)",
        "pendingNew": "Neu",
        "taskGroupsTitle": "Massnahmengruppen",
        "taskGroupsDescription": "Gruppieren Sie Massnahmen in Phasen oder Ziele (z.B. Phase 1, Phase 2). Diese Gruppen können auf der Roadmap visualisiert werden.",
        "addGroup": "+ Gruppe hinzufügen",
        "groupName": "Gruppen-Name (z.B. Phase 1)",
        "groupDeleteWarning": "Achtung: Massnahmen in dieser Gruppe werden der Gruppe 'Keine' zugewiesen.",
        "keineGruppen": "Keine Massnahmengruppen definiert.",
        "openMeasure": "offene Massnahme",
        "openMeasures": "offene Massnahmen"
    },
    "tasks": {
        "noDate": "OHNE DATUM",
        "today": "Heute",
        "unnamed": "Unbenannt",
        "boardReadOnly": "Nur lesbar: Karten auf diesem Board lassen sich nicht verschieben.",
        "kpiMeasures": "Massnahmen",
        "boardSorts": {
            "label": "Sortierung",
            "manual": "Manuell",
            "alphabetical": "A-Z",
            "dueDate": "Fälligkeitsdatum",
            "taskSize": "Grösse"
        },
        "promise": "Promise",
        "reset": "Zurücksetzen",
        "neueAufgabe": "Neue Aufgabe",
        "viewMode": {
            "timeline": "Zeitleiste"
        },
        "searchPlaceholder": "Suchen nach Titel, Beschreibung...",
        "filters": {
            "responsibleAll": "Verantwortlich (Alle)",
            "labelAll": "Label (Alle)",
            "labelPrefix": "Label",
            "dueDateAll": "Fälligkeit (Alle)",
            "dueDateNext30": "Fällig in den nächsten 30 Tagen",
            "dueDateOverdue": "Überfällig"
        },
        "status": {
            "TODO": "Offen",
            "IN_PROGRESS": "In Arbeit",
            "REVIEW": "Review",
            "DONE": "Erledigt"
        },
        "report": {
            "taskCount_one": "{{count}} Massnahme",
            "taskCount_other": "{{count}} Massnahmen",
            "title": "Massnahmen-Bericht"
        }
    },
    "myTasks": {
        "title": "Meine Aufgaben",
        "intro": "Hier finden Sie alle Aufgaben, die Ihnen zugewiesen sind.",
        "kpi": {
            "open": "Offene Tasks",
            "dueSoon": "Fällig (30 Tage)",
            "overdue": "Überfällig",
            "openSubtext": "Weder abgeschlossen noch archiviert",
            "dueSoonSubtext": "Fällig innerhalb der nächsten 30 Tage",
            "overdueSubtext": "Fälligkeitsdatum bereits überschritten"
        },
        "list": {
            "taskName": "Aufgabe",
            "project": "Projekt",
            "startDate": "Startdatum",
            "dueDate": "Fälligkeitsdatum",
            "status": "Status"
        },
        "filters": {
            "search": "Suchen...",
            "project": "Projekt",
            "status": "Status",
            "reset": "Zurücksetzen",
            "projectAll": "Projekt (Alle)"
        },
        "noTasks": "Ihnen sind aktuell keine Aufgaben zugewiesen."
    },
    "portfolio": {
        "keineProjektleitung": "Keine Projektleitung",
        "loadError": "Fehler beim Laden der Projekte.",
        "wipLimitWarning": "Achtung: Das konfigurierte Kapazitätslimit für diese Projektgrösse ist bereits erreicht. Weitere Projekte in die Umsetzung zu nehmen, führt erfahrungsgemäss zu Engpässen und Verzögerungen bei laufenden Vorhaben.",
        "wipLimitQuestion": "Möchten Sie dieses Projekt aufgrund dringlicher Prioritäten oder einer Eskalation trotzdem in die Umsetzung aufnehmen?",
        "filterClear": "Filter aufheben",
        "healthAtRisk": "Kritischer Puls",
        "healthOnTrack": "Auf Kurs",
        "title": "Projektportfolio",
        "searchPlaceholder": "Suchen nach Titel, Beschreibung, Projektleitung...",
        "intro": "Verwalten Sie Ihre strategischen Umsetzungsprojekte.",
        "newProject": "Neues Projekt",
        "noProjects": "Noch keine Projekte vorhanden. Starten Sie mit der Umsetzung Ihrer CAF-Ziele.",
        "ungueltigeVerantwortlichkeitTitle": "Verantwortlichkeit ungültig",
        "statusLabel": "Status:",
        "status": {
            "IDEA": "Idee",
            "EVALUATING": "In Prüfung",
            "IN_PROGRESS": "In Umsetzung",
            "ON_HOLD": "Pausiert",
            "COMPLETED": "Abgeschlossen",
            "ARCHIVED": "Archiviert"
        },
        "kpi": {
            "total": "Alle Projekte",
            "active": "Aktiv",
            "completed": "Abgeschlossen",
            "atRisk": "Kritischer Puls",
            "decisionNeeded": "Entscheidungen"
        },
        "filters": {
            "originUnitGroup": "Herkunftseinheit",
            "ownCategories": "Eigene Kategorien",
            "topicCategories": "Querschnittsthemen",
            "all": "Alle (ohne archiviert)",
            "active": "Nur Aktive",
            "decision": "Entscheidungen",
            "missingRatings": "Fehlende Bewertungen",
            "category": "Kategorie",
            "save": "Filter speichern",
            "saveTooltip": "Aktuelle Filterauswahl für diesen Benutzer speichern",
            "saved": "Gespeichert",
            "categoryAll": "Kategorie (Alle)",
            "allOrgUnits": "Organisationseinheit (Alle)",
            "relationAll": "Herkunft (Alle)",
            "relationOwn": "Eigene Einheit",
            "relationPromoted": "Weitergegeben",
            "relationTopic": "Querschnittsthema"},
        "itPortfolioFilter": "Nur IT-Projekte",
        "boardSorts": {
            "label": "Sortierung",
            "manual": "Manuell",
            "alphabetical": "Alphabetisch",
            "dueDate": "Zieltermin",
            "projectSize": "Projektgrösse"
        },
        "matrixWarning": "Einige Projekte werden in der Matrix nicht angezeigt, da ihnen Aufwandsschätzung, strategische Bedeutung oder Nutzen fehlen.",
        "unratedProjectsWarning": "Folgende Projekte sind noch nicht bewertet und können daher nicht im Chart angezeigt werden.",
        "showMissing": "In Listenansicht anzeigen",
        "viewMode": {
            "list": "Liste",
            "matrix": "Matrix",
            "kanban": "Kanban",
            "roadmap": "Road Map"
        },
        "export": {
            "page": "Seite",
            "projectOverviewTitle": "Projektübersicht",
            "tableHeaderProject": "Projekt",
            "tableHeaderPulseCheck": "Puls-Check",
            "chartRenderError": "Diagramm konnte nicht gerendert werden.",
            "noCafReference": "Kein CAF-Bezug",
            "trafficLightsTitle": "Status-Ampeln:",
            "button": "Aktuelle Ansicht exportieren",
            "title": "Portfolio als PDF exportieren",
            "subtitle": "Der Export übernimmt die aktuelle Ansicht, Filter und Sortierung.",
            "includeDetails": "Projektdetails ausgeben",
            "includeStatus": "Projektstatus ausgeben (Ampeln, Management Summary, Entscheide)",
            "groupBy": "Projektdetails gruppieren nach",
            "groupByNone": "Keine Gruppierung",
            "groupByStatus": "Status",
            "groupByResponsible": "Verantwortlichkeit",
            "groupByCafCriterion": "CAF-Kriterium",
            "generating": "Generiere...",
            "create": "PDF erstellen",
            "cancel": "Abbrechen",
            "reportTitle": "Projektportfolio-Bericht",
            "organization": "Organisation:",
            "viewModeLabel": "Ansicht:",
            "filterActive": "Filter aktiv",
            "createdOn": "Erstellt am:",
            "unnamedProject": "Unbenanntes Projekt",
            "noDate": "OHNE DATUM",
            "today": "Heute",
            "noData": "Ohne Daten:",
            "benefitAxis": "Nutzen (Tief \u2192 Hoch)",
            "strategyAxis": "Strategischer Bezug (Tief \u2192 Hoch)",
            "capacityLimit": "KAPAZITÄTSAUSLASTUNG",
            "unnamedBucket": "Unbenannt",
            "projectCount": "Projekte"
        },
        "strategiebezug": "Strategiebezug:",
        "aufwand": "Aufwand:",
        "nutzen": "Nutzen:",
        "chartXAxis": "Strategischer Bezug (Tief ➔ Hoch)",
        "chartYAxisBenefit": "Nutzen (Tief ➔ Hoch)",
        "chartYAxisEffort": "Aufwand (Tief ➔ Hoch)",
        "chartBubbleSize": "Bubble-Grösse",
        "chartBubbleScaledBenefit": "Skalierter Projektnutzen (1-10)",
        "chartBubbleEstimatedEffort": "Geschätzter Aufwand (S-XL)",
        "gesetzlicherAuftrag": "Gesetzlicher Auftrag",
        "board": "Board",
        "reset": "Zurücksetzen",
        "zeit": "Zeit",
        "budget": "Budget",
        "team": "Team",
        "qualitaet": "Qualität",
        "kapazitaetsauslastung": "Kapazitätsauslastung",
        "keineProjekteZurDarstellungGefunden": "Keine Projekte zur Darstellung gefunden.",
        "normalesProjekt": "Normales Projekt",
        "wipLimitUeberschritten": "WIP-Limit überschritten",
        "abbrechen": "Abbrechen",
        "trotzdemFortfahren": "Trotzdem fortfahren",
        "keineAngabe": "Keine Angabe",
        "keinStatus": "Kein Status",
        "aufKurs": "Auf Kurs",
        "ungewiss": "Ungewiss",
        "kritisch": "Kritisch",
        "cafBezugAlle": "CAF-Bezug (Alle)",
        "projektleitungAlle": "Projektleitung (Alle)",
        "project": "Projekt",
        "projectList": "Projektliste",
        "moveLock": {
            "foreign": "Projekt kann nicht verschoben werden, da es von {{unit}} verwaltet wird.",
            "noRight": "Nur die Portfolio-Verwaltung oder die verantwortliche Person kann dieses Projekt verschieben."
        },
        "relation": {
            "promotedFrom": "Weitergegeben von {{unit}}",
            "topic": "Thema {{topics}} · {{unit}}",
            "personal": "Mitwirkung · {{unit}}"
        }
    },
    "project": {
        "labels": "Labels",
        "noAccess": "Sie haben keinen Zugriff auf dieses Projekt.",
        "loadError": "Fehler beim Laden des Projekts.",
        "details": "Projektdetails",
        "title": "Projektname",
        "description": "Ziele & Beschreibung",
        "initialSituation": "Ausgangslage",
        "managementSummary": "Management Summary",
        "sponsor": "Auftraggeber / Sponsor",
        "steeringCommittee": "Projektausschuss",
        "measurableSuccess": "Messbarer Erfolg",
        "cafReference": "CAF-Bezug",
        "category": "Kategorie",
        "responsible": "Projektleitung",
        "startDate": "Startdatum",
        "dueDate": "Zieldatum",
        "effortEstimate": "Geschätzter Aufwand",
        "notEstimated": "Nicht geschätzt",
        "strategicImportance": "Strategische Bedeutung",
        "benefit": "Nutzen (Intern / Extern)",
        "isLegalRequirement": "Gesetzlicher Auftrag",
        "status": "Status",
        "decisionNeeded": "Eskalation / Entscheidungsbedarf",
        "decisionNeededPlaceholder": "Was muss der Steuerungsausschuss / die GL entscheiden, damit das Projekt weitergeht?",
        "addEscalation": "Entscheidungsbedarf hinzufügen",
        "saveEscalation": "Hinzufügen",
        "noEscalations": "Kein aktueller Entscheidungsbedarf.",
        "activeEscalations": "Notwendige Entscheide",
        "resolveEscalationBtn": "Entscheid dokumentieren",
        "recordDecisionTitle": "Entscheidung dokumentieren",
        "recordDecisionIntro": "Halten Sie fest, was bezüglich der aktuellen Eskalation entschieden wurde. Dieser Entscheid wird nach dem Speichern in die Historie verschoben.",
        "decision": "Getroffener Entscheid",
        "logDecisionBtn": "Entscheid eintragen",
        "decisionHistory": "Entscheidungshistorie",
        "trafficLights": {
            "title": "Puls-Check (Ampeln)",
            "time": "Zeit / Termin",
            "budget": "Kosten / Budget",
            "resources": "Ressourcen / Team",
            "quality": "Qualität / Scope"
        },
        "deleteTitle": "Projekt löschen?",
        "deleteMessage": "Sind Sie sicher, dass Sie dieses Projekt inkl. aller Tasks unwiderruflich löschen möchten?",
        "archiveWarningTitle": "Projekt archivieren?",
        "archiveWarningMessage": "Wenn Sie den Status auf 'Archiviert' setzen, werden auch alle Massnahmen (Tasks) dieses Projektes archiviert. Möchten Sie fortfahren?",
        "archiveWarningConfirm": "Ja, archivieren",
        "export": {
            "button": "Aktuelle Ansicht exportieren",
            "title": "Projekt als PDF exportieren",
            "subtitle": "Wählen Sie die gewünschten Abschnitte für den Export.",
            "optionDetails": "Projektdetails",
            "optionPulseCheck": "Puls-Check",
            "optionPulseCheckSummary": "Puls-Check (inkl. Management Summary)",
            "optionTaskOverview": "Massnahmenübersicht",
            "optionTaskDetails": "Massnahmendetails",
            "optionRisks": "Projektrisiken",
            "optionDecisions": "Notwendige Entscheide",
            "decisionNone": "Keine",
            "decisionOpen": "Nur offene Entscheide",
            "decisionAll": "Alle Entscheide (inkl. Historie)",
            "detailsTitle": "Projektdetails exportieren",
            "tasksTitle": "Massnahmen exportieren",
            "cancel": "Abbrechen",
            "create": "PDF erstellen",
            "generating": "Generiere..."
        },
        "report": {
            "title": "Projekt-Bericht",
            "decisionHistoryTitle": "Notwendige Entscheide & Historie",
            "decisionOpenTitle": "Offene Entscheide (Eskalationen):",
            "decisionNone": "Aktuell keine offenen Entscheide.",
            "decisionHistorySubtitle": "Entscheidungshistorie (bereits getroffen):",
            "decisionHistoryNone": "Keine Historie vorhanden.",
            "decisionDate": "Entschieden am",
            "decisionQuestion": "Frage:",
            "decisionAnswer": "Entscheid:",
            "riskTitle": "Projektrisiken",
            "riskMatrixTitle": "Risikomatrix",
            "riskListTitle": "Risikoliste",
            "riskProb": "Wahrscheinlichkeit (1 - 4)",
            "riskDamage": "Schadenausmass (1 - 4)",
            "riskNo": "Nr.",
            "riskName": "Risikoname",
            "riskTableDamage": "Schaden",
            "riskTableProb": "Wahrsch.",
            "riskDesc": "Beschreibung"
        },
        "newProject": "Neues Projekt",
        "notFound": "Projekt nicht gefunden"
    },
    "backend": {
        "errors": {
            "ungueltigeEingabe": "Ungültige Eingabe.",
            "unerwarteterFehler": "Es ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
            "nurTenantAdmins": "Diese Aktion ist nur für Tenant Admins zulässig.",
            "keineBerechtigungFuerEinheit": "Keine Berechtigung für diese Organisationseinheit.",
            "organisationseinheitNichtGefunden": "Organisationseinheit nicht gefunden.",
            "organisationseinheitFehlt": "Die Organisationseinheit fehlt.",
            "organisationseinheitFehltOderDeaktiviert": "Die Organisationseinheit existiert nicht oder ist deaktiviert.",
            "keineOrganisationseinheitZugeordnet": "Ihnen ist keine Organisationseinheit zugeordnet.",
            "uebergeordneteEinheitNichtGefunden": "Die übergeordnete Einheit wurde nicht gefunden.",
            "uebergeordneteEinheitFehltOderDeaktiviert": "Die übergeordnete Einheit existiert nicht oder ist deaktiviert.",
            "nameDerEinheitFehlt": "Der Name der Organisationseinheit ist erforderlich.",
            "obersteEinheitNichtVerschiebbar": "Die oberste Einheit kann nicht verschoben werden.",
            "einheitNichtSichSelbstUnterstellt": "Eine Einheit kann nicht sich selbst unterstellt werden.",
            "verschiebenUnterDeaktivierteEinheit": "Einheiten können nicht unter eine deaktivierte Einheit verschoben werden.",
            "zirkulaereHierarchie": "Die neue übergeordnete Einheit liegt unterhalb der verschobenen Einheit. Das ergäbe eine zirkuläre Hierarchie.",
            "zuVieleEbenenNachVerschiebung": "Nach der Verschiebung hätte die Struktur mehr Ebenen als zulässig.",
            "anlegenUnterDeaktivierterEinheit": "Unter einer deaktivierten Einheit können keine Einheiten angelegt werden.",
            "hoechsteEbeneErreicht": "Die Organisationsstruktur hat bereits die zulässige Höchstzahl an Ebenen.",
            "einfuegenHoechsteEbeneErreicht": "Die Struktur hat bereits die zulässige Höchstzahl an Ebenen; darüber kann keine Einheit eingefügt werden.",
            "mandantHatBereitsObersteEinheit": "Der Mandant besitzt bereits eine oberste Einheit.",
            "obersteEinheitNichtDeaktivierbar": "Die oberste Einheit kann nicht deaktiviert werden.",
            "zuerstUntereinheitenDeaktivieren": "Bitte deaktivieren Sie zuerst alle untergeordneten Einheiten.",
            "verschiebenBestaetigen": "Beim Verschieben werden Freigaben oder Weitergaben aufgelöst. Bitte bestätigen Sie die Folgen.",
            "keineEindeutigeObersteEinheit": "Die Organisationsstruktur hat keine eindeutige oberste Einheit. Bitte kontaktieren Sie den Support.",
            "obersteEinheitGenauEineUntereinheit": "Die oberste Einheit kann nur entfernt werden, wenn sie genau eine Untereinheit hat.",
            "verbleibendeEinheitDeaktiviert": "Die verbleibende Einheit ist deaktiviert und kann nicht oberste Einheit werden.",
            "obersteEinheitHatPersonen": "Der obersten Einheit sind Personen zugeordnet. Sie kann nicht mehr entfernt werden.",
            "obersteEinheitHatAssessments": "Die oberste Einheit besitzt Assessments. Sie kann nicht mehr entfernt werden.",
            "obersteEinheitHatFreigaben": "Der obersten Einheit wurden bereits Assessments freigegeben. Sie kann nicht mehr entfernt werden.",
            "obersteEinheitHatProjekte": "Die oberste Einheit besitzt Projekte. Sie kann nicht mehr entfernt werden.",
            "obersteEinheitHatWeitergaben": "Der obersten Einheit wurden bereits Projekte weitergegeben. Sie kann nicht mehr entfernt werden.",
            "obersteEinheitHatQuerschnittsthema": "Die oberste Einheit ist für ein Querschnittsthema zuständig. Sie kann nicht mehr entfernt werden.",
            "obersteEinheitNichtLoeschbar": "Die oberste Einheit kann nicht gelöscht werden.",
            "einheitHatUntereinheiten": "Diese Organisationseinheit besitzt noch untergeordnete Einheiten.",
            "einheitHatPersonen": "Dieser Organisationseinheit sind noch Personen zugeordnet.",
            "einheitHatAssessments": "Diese Organisationseinheit besitzt Assessments. Bitte deaktivieren Sie sie, statt sie zu löschen.",
            "einheitHatProjekte": "Diese Organisationseinheit besitzt Projekte. Bitte deaktivieren Sie sie, statt sie zu löschen.",
            "einheitHatQuerschnittsthema": "Diese Organisationseinheit ist für ein Querschnittsthema zuständig.",
            "projekteAnlegenNurPortfolioUndProjektleitung": "Projekte anlegen dürfen das Portfoliomanagement und die Projektleitung.",
            "querschnittsthemenNurPortfoliomanagement": "Querschnittsthemen ordnet das Portfoliomanagement der Herkunftseinheit zu.",
            "weitergebenNurPortfoliomanagement": "Weitergeben darf nur das Portfoliomanagement der Einheit, bei der das Projekt aktuell liegt.",
            "obersteEinheitKannNichtWeitergeben": "Die oberste Einheit kann keine Projekte weitergeben.",
            "zurueckziehenNurPortfoliomanagement": "Eine Weitergabe zurückziehen darf nur das Portfoliomanagement.",
            "projektNichtVonIhrerEinheitWeitergegeben": "Ihre Einheit hat dieses Projekt nicht weitergegeben.",
            "unbekanntesQuerschnittsthema": "Unbekanntes oder deaktiviertes Querschnittsthema.",
            "querschnittsthemaDeaktiviert": "Das Querschnittsthema ist deaktiviert.",
            "sichtDerEinheitNurPortfoliomanagement": "Die Sicht der Einheit pflegt das Portfoliomanagement.",
            "projektFuerEinheitNichtFreigegeben": "Das Projekt ist für Ihre Einheit nicht freigegeben.",
            "unbekannteKategorie": "Unbekannte Kategorie.",
            "unbekannterPortfoliostatus": "Unbekannter Portfoliostatus.",
            "notizLeer": "Die Notiz ist leer.",
            "notizNichtGefunden": "Notiz nicht gefunden.",
            "nurEigeneNotizenLoeschen": "Sie können nur eigene Notizen löschen.",
            "projekteLoeschenNurPortfoliomanagement": "Projekte löscht das Portfoliomanagement der Herkunftseinheit.",
            "ungueltigeProjektdaten": "Die Projektdaten sind ungültig. Bitte prüfen Sie Ihre Eingaben.",
            "titelFehlt": "Der Titel fehlt.",
            "assessmentNichtGefunden": "Assessment nicht gefunden.",
            "keineBerechtigungFuerAssessmentsDerEinheit": "Keine Berechtigung für Assessments dieser Organisationseinheit.",
            "assessmentAbgeschlossen": "Das Assessment ist abgeschlossen. Bitte öffnen Sie es zuerst wieder.",
            "aktionImStatusNichtMoeglich": "Diese Aktion ist im aktuellen Status nicht möglich.",
            "assessmentsAnlegenNurQmManagement": "Assessments legt das QM-Management an.",
            "obersteEinheitOhneUebergeordnete": "Die oberste Einheit hat keine übergeordnete Einheit.",
            "bewertungBereitsEingereicht": "Diese Bewertung wurde bereits eingereicht.",
            "aggregatNurQmUndManagement": "Das Aggregat sehen nur das QM-Management und das Management der eigenen Einheit.",
            "vergleichswerteNurQmUndManagement": "Vergleichswerte sehen nur das QM-Management und das Management.",
            "ungueltigeFarbe": "Ungültige Farbe.",
            "zustaendigeEinheitFehlt": "Die zuständige Einheit fehlt.",
            "nameFehlt": "Der Name fehlt.",
            "nameZuLang": "Der Name ist zu lang.",
            "querschnittsthemaNichtGefunden": "Querschnittsthema nicht gefunden.",
            "kategorienNurPortfoliomanagement": "Kategorien pflegt das Portfoliomanagement der Einheit.",
            "kategorieNichtGefunden": "Kategorie nicht gefunden.",
            "mindestensEinStatus": "Es braucht mindestens einen Status.",
            "statusIdsNichtEindeutig": "Die Status-IDs sind nicht eindeutig.",
            "statusNamenDoppelt": "Zwei Status haben denselben Namen.",
            "startNachFaelligkeit": "Das Startdatum darf nicht nach dem Fälligkeitsdatum liegen.",
            "erinnerungNachFaelligkeit": "Das Erinnerungsdatum darf nicht nach dem Fälligkeitsdatum liegen.",
            "statusFehlt": "Der Status fehlt.",
            "kommentarLeer": "Der Kommentar darf nicht leer sein.",
            "farbeFehlt": "Die Farbe fehlt.",
            "risikonameFehlt": "Der Name des Risikos fehlt.",
            "keineBerechtigungBenutzerLoeschen": "Keine Berechtigung zum Löschen von Benutzern.",
            "superAdminsNichtLoeschbar": "Super Admins können nicht gelöscht werden.",
            "orgAdminsNurEigeneEinheitEntfernen": "Org Admins dürfen nur Benutzer der eigenen Organisationseinheit entfernen.",
            "orgAdminsKeineTenantAdminsLoeschen": "Org Admins können keine Tenant Admins löschen.",
            "spracheNichtVerfuegbar": "Diese Sprache ist für Ihren Mandanten nicht freigeschaltet.",
            "keineBerechtigungRollenBearbeiten": "Keine Berechtigung zum Bearbeiten von Rollen.",
            "superAdminsUndAssessorenNichtHier": "Super Admins und Assessoren werden hier nicht verwaltet.",
            "orgAdminsNurEigeneEinheitRollen": "Org Admins dürfen nur Rollen der eigenen Organisationseinheit anpassen.",
            "orgAdminsKeineTenantAdminsErnennen": "Org Admins können keine Tenant Admins ernennen.",
            "benutzerNichtImMandanten": "Der Benutzer gehört nicht zu diesem Mandanten.",
            "totpAktivierenFehlgeschlagen": "Die Anmeldung mit Authenticator-App (TOTP) konnte nicht aktiviert werden.",
            "konfigurationSpeichernFehlgeschlagen": "Die Konfiguration konnte nicht gespeichert werden.",
            "datenexportFehlgeschlagen": "Der Datenexport ist fehlgeschlagen.",
            "loeschungFehlgeschlagen": "Die Löschung ist fehlgeschlagen.",
            "einladenNurAdmins": "Nur Tenant Admins und Org Admins dürfen Benutzer einladen.",
            "orgAdminsNurEigeneEinheitEinladen": "Org Admins dürfen Benutzer nur in die eigene Organisationseinheit einladen.",
            "assessorenEinladenNurAdmins": "Nur Tenant Admins und Org Admins dürfen externe Assessoren einladen.",
            "assessorHinzufuegenFehlgeschlagen": "Der Assessor konnte nicht hinzugefügt werden.",
            "keineBerechtigungAssessorenEntfernen": "Keine Berechtigung zum Entfernen von Assessoren.",
            "assessorNichtGefunden": "Assessor nicht gefunden.",
            "orgAdminsNurEigeneAssessorenEntfernen": "Org Admins dürfen nur Assessoren der eigenen Organisationseinheit entfernen.",
            "orgAdminsKeineMandantenweitenAssessoren": "Org Admins können keine mandantenweiten Assessoren entfernen.",
            "ungueltigeEmail": "Ungültige E-Mail-Adresse.",
            "einladungNichtGefunden": "Die Einladung wurde nicht gefunden. Bitte prüfen Sie den Link.",
            "einladungBereitsVerwendet": "Diese Einladung wurde bereits verwendet.",
            "einladungAbgelaufen": "Die Einladung ist abgelaufen. Bitte fordern Sie eine neue an.",
            "anzeigenameFehlt": "Der Anzeigename fehlt.",
            "idpEntityIdFehlt": "Die IdP Entity ID fehlt.",
            "ssoUrlUngueltig": "Die SSO-URL muss eine gültige URL sein.",
            "zertifikatFehlt": "Das Zertifikat ist zu kurz oder fehlt.",
            "ssoDomainFehlt": "Mindestens eine SSO-Domain ist erforderlich.",
            "clientIdFehlt": "Die Client ID fehlt.",
            "issuerUrlUngueltig": "Die Issuer-URL muss eine gültige URL sein.",
            "ssoKonfigurationFehlgeschlagen": "Fehler bei der SSO-Konfiguration.",
            "ssoEntfernenFehlgeschlagen": "Fehler beim Entfernen der SSO-Konfiguration.",
            "oidcKonfigurationFehlgeschlagen": "Fehler bei der OIDC-Konfiguration.",
            "keineSsoKonfigurationFuerDomain": "Für die Domain Ihrer E-Mail-Adresse ist kein SSO eingerichtet.",
            "benutzerErstellungFehlgeschlagen": "Das Benutzerkonto konnte nicht erstellt werden.",
            "sicherheitspruefungFehlgeschlagen": "Die Sicherheitsprüfung ist fehlgeschlagen. Bitte laden Sie die Seite neu.",
            "cafStructureSaveFailed": "Fehler beim Speichern der Struktur. Haben Sie die nötigen Berechtigungen?",
            "authErforderlich": "Auth erforderlich",
            "falscherMandant": "Falscher Mandant.",
            "fehlerBeimLoeschenDesAuthaccounts": "Fehler beim Löschen des Auth-Accounts. Vorgang abgebrochen, um Dateninkonsistenz zu vermeiden.",
            "benutzerNichtGefunden": "Benutzer nicht gefunden.",
            "zugriffVerweigertFremderMandant": "Zugriff verweigert (Fremder Mandant).",
            "superAdminsKoennenNichtGeaendert": "Super Admins können nicht geändert werden.",
            "sieHabenKeineBerechtigungDie": "Sie haben keine Berechtigung, die Rolle \"Super Admin\" zu vergeben.",
            "authentifizierungErforderlich": "Authentifizierung erforderlich",
            "fehlendeDatenName": "Fehlende Daten: Name.",
            "benutzerExistiertBereits": "Benutzer existiert bereits.",
            "keinMandantZugeordnet": "Kein Mandant zugeordnet.",
            "bewertungKonnteNichtGeladenWerden": "Bewertung konnte nicht geladen werden.",
            "nurAdministratorenDuerfenAssessmentsLoeschen": "Nur Administratoren dürfen Assessments löschen.",
            "youAreNotAuthorizedFor": "Sie sind für diesen Mandanten nicht berechtigt.",
            "youHaveBeenRemovedFrom": "Sie wurden aus diesem Mandanten entfernt.",
            "keineBerechtigungZumAbstimmen": "Keine Berechtigung zum Abstimmen.",
            "nurSuperAdminsDuerfenDiese": "Nur Super Admins dürfen diese Aktion ausführen.",
            "zieluserIstKeinAssessor": "Ziel-User ist kein Assessor.",
            "sieHabenKeineBerechtigungSuper": "Sie haben keine Berechtigung, Super Admins einzuladen.",
            "ungueltigeRolle": "Ungültige Rolle.",
            "benutzerExistiertBereitsImSystem": "Benutzer existiert bereits im System.",
            "keinMandantTenantIdGefunden": "Kein Mandant (Tenant ID) gefunden.",
            "benutzerExistiertBereitsIstAber": "Benutzer existiert bereits, ist aber kein Assessor",
            "mismatchTenantId": "Die Mandanten-ID stimmt nicht überein.",
            "ungueltigerLink": "Ungültiger Link.",
            "falscherLinktyp": "Falscher Link-Typ.",
            "linkAbgelaufen": "Link abgelaufen.",
            "kontoNichtGefunden": "Konto nicht gefunden.",
            "fehlerBeimPruefenDerEinladung": "Fehler beim Prüfen der Einladung.",
            "tokenUngueltig": "Token ungültig.",
            "bereitsVerwendet": "Bereits verwendet.",
            "abgelaufen": "Abgelaufen.",
            "ungueltigerInhaltNachBereinigungLeer": "Ungültiger Inhalt (nach Bereinigung leer).",
            "zuVieleAnfragenBitteVersuchen": "Zu viele Anfragen. Bitte versuchen Sie es später erneut.",
            "fehlerBeimSendenDerNachricht": "Fehler beim Senden der Nachricht.",
            "keineEmailImTokenGefunden": "Keine E-Mail im Token gefunden.",
            "unzureichendeBerechtigungLevel20Erforderlich": "Unzureichende Berechtigung: Level 20 erforderlich.",
            "projektNichtGefunden": "Projekt nicht gefunden.",
            "level20DarfNurZugewiesene": "Level 20 darf nur zugewiesene Projekte bearbeiten.",
            "risikoNichtGefunden": "Risiko nicht gefunden.",
            "level20ErforderlichUmRisiken": "Level 20+ erforderlich, um Risiken zu löschen.",
            "level20DarfNurEigene": "Level 20 darf nur eigene (verantwortete) Projekte bearbeiten.",
            "unzureichendeBerechtigungUmProjektmitgliederZu": "Unzureichende Berechtigung, um Projektmitglieder zu verwalten.",
            "mandantNichtGefunden": "Mandant nicht gefunden.",
            "fehlerBeiDerDomainpruefung": "Fehler bei der Domain-Prüfung.",
            "keineEmailadresseImAuthtoken": "Keine E-Mail-Adresse im Auth-Token.",
            "ungueltigeEmaildomain": "Ungültige E-Mail-Domain.",
            "zugriffVerweigertSieSindKein": "Zugriff verweigert: Sie sind kein Mitglied dieses Projekts.",
            "kommentarNichtGefunden": "Kommentar nicht gefunden.",
            "sieDuerfenNurEigeneKommentare": "Sie dürfen nur eigene Kommentare löschen.",
            "konfigurationsfehlerAiServiceNichtVerfuegbar": "Konfigurationsfehler: AI Service nicht verfügbar.",
            "benutzerIstNichtEingeloggt": "Benutzer ist nicht eingeloggt.",
            "benutzerprofilNichtGefunden": "Benutzerprofil nicht gefunden.",
            "multifaktorauthentifizierungMfaIstFuerDiesen": "Multi-Faktor-Authentifizierung (MFA) ist für diesen Mandanten erforderlich.",
            "mfaZuerstSelbstEinrichten": "Richten Sie zuerst für Ihr eigenes Konto einen zweiten Faktor ein. Erst dann können Sie MFA für alle erzwingen.",
            "keineBerechtigung": "Keine Berechtigung.",
            "projektleitungAendertPortfoliomanagement": "Die Projektleitung wird vom Portfoliomanagement der Herkunftseinheit bestimmt.",
            "kiFuerMandantAusgeschaltet": "Die KI-Funktionen sind für diesen Mandanten ausgeschaltet.",
            "kiAbrechnung": "Die KI ist wegen eines Abrechnungsproblems nicht verfügbar. Bitte informieren Sie den Support.",
            "kiModellNichtVerfuegbar": "Das KI-Modell ist im Moment nicht verfügbar. Bitte informieren Sie den Support.",
            "kiAusgelastet": "Die KI ist im Moment ausgelastet. Bitte versuchen Sie es in einigen Minuten nochmals.",
            "kiNichtErreichbar": "Die KI ist im Moment nicht erreichbar. Bitte versuchen Sie es später nochmals.",
            "kiKeineAntwort": "Die KI hat keine verwertbare Antwort geliefert. Bitte versuchen Sie es nochmals.",
            "kiTageslimitErreicht": "Das Tageslimit für die KI-Funktionen ist erreicht. Bitte versuchen Sie es morgen wieder.",
            "kiTextZuLang": "Der Text ist für die KI zu lang. Bitte kürzen Sie ihn.",
            "fehlerBeiDerBerechtigungspruefung": "Fehler bei der Berechtigungsprüfung.",
            "tenantidFehltFuerDieBerechtigungspruefung": "tenantId fehlt für die Berechtigungsprüfung.",
            "zugriffAufDiesenMandantenVerweigert": "Zugriff auf diesen Mandanten verweigert.",
            "mandantGesperrt": "Der Mandant ist gesperrt. Der Zugriff ist nicht möglich.",
            "mandantGesperrtKeineZugaenge": "Der Mandant ist gesperrt. Es lassen sich keine Personen und keine Assessoren hinzufügen.",
            "mandantGesperrtKeineEinreichung": "Der Mandant ist gesperrt und nimmt keine Bewertungen entgegen.",
            "adminSaveFailed": "Fehler beim Speichern. Dies ist oft ein Berechtigungsproblem."
        }
    },
    "aisettings": {
        "promise": "Promise"
    },
    "riskHistory": {
        "taskCreated": "Massnahme erstellt",
        "damageChanged": "Schadenausmass: {{from}} → {{to}}",
        "probabilityChanged": "Wahrscheinlichkeit: {{from}} → {{to}}",
        "nameChanged": "Titel geändert",
        "descriptionChanged": "Beschreibung geändert",
        "noChanges": "Keine relevanten Änderungen",
        "created": "Erstellt"
    },
    "contentmanagement": {
        "globaleVorlagen": "Globale Vorlagen",
        "meineOrganisation": "Meine Organisation",
        "typ": "Typ",
        "gesperrt": "Gesperrt",
        "zentralVerwaltetHinweis": "Hinweis: Diese Inhalte werden zentral verwaltet und können nur von System-Administratoren bearbeitet werden.",
        "verfuegbareMethoden": "Verfügbare Methoden ({{count}})",
        "id": "ID",
        "abschnittLoeschen": "Abschnitt löschen",
        "beispielEntfernen": "Beispiel entfernen",
        "methodenList": "Methodenliste",
        "modulLoeschen": "Modul löschen",
        "methodeLoeschen": "Methode löschen",
        "beispielLoeschen": "Beispiel löschen",
        "themenfeldLoeschenFrage": "Möchten Sie das Themenfeld \"<strong>{{title}}</strong>\" und alle enthaltenen Kriterien wirklich löschen?",
        "kriteriumLoeschenFrage": "Möchten Sie das Kriterium \"<strong>{{title}}</strong>\" wirklich löschen?",
        "modulLoeschenFrage": "Möchten Sie das Informationsmodul \"<strong>{{title}}</strong>\" wirklich löschen?",
        "abschnittLoeschenFrage": "Möchten Sie den Abschnitt \"<strong>{{title}}</strong>\" wirklich löschen?",
        "methodeEntfernenFrage": "Möchten Sie die Methode \"<strong>{{title}}</strong>\" wirklich aus dem Baukasten entfernen?",
        "beispielEntfernenFrage": "Möchten Sie das Beispiel \"<strong>{{title}}</strong>\" wirklich entfernen?",
        "ok": "OK",
        "promise": "Promise",
        "inhalteExportieren": "Inhalte exportieren",
        "cafThemenfelderKriterien": "CAF Themenfelder & Kriterien",
        "informationsbereiche": "Informationsbereiche",
        "methodenbaukasten": "Methodenbaukasten",
        "standardIndividualisierung": "Standard & Individualisierung",
        "inhalteMitEinemSchlossSymbol": "Inhalte mit einem Schloss-Symbol (",
        "standardContentInfo": "Inhalte mit einem Schloss-Symbol sind Teil des globalen CAF-Standards und können nicht bearbeitet werden. Sie können jedoch eigene Themenfelder, Kriterien und Beispiele ergänzen.",
        "beschreibung": "Beschreibung",
        "detailbeschreibung": "Detailbeschreibung",
        "beispiele": "Beispiele",
        "beispielHinzufuegen": "Beispiel hinzufügen",
        "kriteriumHinzufuegen": "Kriterium hinzufügen",
        "neuesThemenfeldHinzufuegen": "Neues Themenfeld hinzufügen",
        "ueberInformationsmodule": "Über Informationsmodule",
        "dieseModuleWerdenImLern": "Diese Module werden im Lern-Hub oberhalb der Themenfelder angezeigt. Sie dienen der allgemeinen Information über CAF.",
        "modulTitel": "Modul Titel",
        "einleitungBeschreibung": "Einleitung / Beschreibung",
        "abschnittHinzufuegen": "Abschnitt hinzufügen",
        "neuesInformationsmodulHinzufuegen": "Neues Informationsmodul hinzufügen",
        "zentraleSammlungVonMethodenDie": "Zentrale Sammlung von Methoden, die mit CAF Kriterien verknüpft sind. Diese sind für alle Mandanten sichtbar.",
        "methodeHinzufuegen": "Methode hinzufügen",
        "titel": "Titel",
        "zielZweck": "Ziel/Zweck",
        "aktionen": "Aktionen",
        "keineMethodenVorhanden": "Keine Methoden vorhanden.",
        "achtung": "ACHTUNG:",
        "diesEntferntAlleIhreIndividuellen": "Dies entfernt alle Ihre individuellen Erweiterungen. Es bleiben nur die Standard-Inhalte des CAF-Modells übrig. Dies kann nicht rückgängig gemacht werden.",
        "themenfeldLoeschen": "Themenfeld löschen",
        "kriteriumLoeschen": "Kriterium löschen",
        "methodenDurchsuchen": "Methoden durchsuchen...",
        "themenfeldWaehlen": "Themenfeld wählen...",
        "kriteriumWaehlen": "Kriterium wählen...",
        "bearbeiten": "Bearbeiten",
        "loeschen": "Löschen",
        "themenfeld": "Themenfeld",
        "kriterium": "Kriterium",
        "beispiel": "Beispiel",
        "abschnitt": "Abschnitt",
        "inhalt": "Inhalt"
    },
    "finishassessorregistration": {
        "keinGueltigerLink": "Kein gültiger Link gefunden.",
        "einladungslinkUngueltig": "Der Einladungs-Link ist abgelaufen oder ungültig.",
        "esIstEinFehlerAufgetreten": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
        "erfolgreich": "Erfolgreich!",
        "abschlussFehlgeschlagen": "Abschluss fehlgeschlagen.",
        "dieRegistrierungWarErfolgreichSie": "Die Registrierung war erfolgreich. Sie werden in Kürze weitergeleitet...",
        "speichere": "Speichere...",
        "registrierungAbschliessenBtn": "Registrierung abschliessen",
        "linkUngueltig": "Link ungültig",
        "zurueckZumLogin": "Zurück zum Login",
        "registrierungAbschliessen": "Registrierung abschliessen",
        "vervollstaendigenSieIhrProfilFuer": "Vervollständigen Sie Ihr Profil für",
        "ihrName": "Ihr Name",
        "firmaOrganisation": "Firma / Organisation",
        "passwort": "Passwort",
        "wiederholen": "Wiederholen",
        "vornameNachname": "Vorname Nachname",
        "consultingGmbh": "Consulting GmbH"
    },
    "mfasetup": {
        "qrCodeAlt": "QR-Code für die Authenticator-App",
        "seiteNeuLadenWennBestaetigt": "Seite neu laden (wenn bestätigt)",
        "oeffnenSieIhreAuthenticatorApp": "Öffnen Sie Ihre Authenticator App (Google Authenticator, Microsoft Authenticator o.ä.) und scannen Sie diesen Code.",
        "gebenSieDen6Stelligen": "Geben Sie den 6-stelligen Code ein",
        "ihrKontoIstNunZusaetzlich": "Ihr Konto ist nun zusätzlich geschützt. Sie werden in Kürze weitergeleitet.",
        "zumDashboard": "Zum Dashboard"
    },
    "mytasks": {
        "keineAufgabenEntsprechenDenGewaehlten": "Keine Aufgaben entsprechen den gewählten Filtern."
    },
    "projectdetail": {
        "projektbewertungPriorisierung": "Projektbewertung & Priorisierung",
        "ungueltigeVerantwortlichkeit": "Verantwortlichkeit ungültig",
        "dieAktuellZugewiesenePersonIst": "Die aktuell zugewiesene Person ist kein Benutzer dieses Mandanten mehr. Bitte weisen Sie eine neue Projektleitung zu.",
        "statusSchnelleinschaetzung": "Status-Schnelleinschätzung",
        "entschieden": "ENTSCHIEDEN",
        "urspruenglichesProblem": "Ursprüngliche Frage:",
        "projektEinstellungen": "Projekt-Einstellungen",
        "exportieren": "Projektdetails exportieren",
        "tabs": "Tabs",
        "bitteWaehlen": "Bitte wählen...",
        "kurzerStatusbericht": "Kurzer Statusbericht...",
        "loeschen": "Löschen",
        "wasWurdeEntschieden": "Was wurde entschieden...?",
        "tasksTab": "Massnahmen (Tasks)",
        "nichtGeschaetzt": "Nicht geschätzt",
        "foreignProjectNote": "Dieses Projekt gehört zu {{unit}}. Sie sehen Projektdaten und Risiken, bearbeiten es aber nicht.",
        "sharingTab": "Weitergabe",
        "evaluationByPortfolio": "Bewertet das Portfoliomanagement",
        "evaluationOfOrigin": "Bewertung der Herkunftseinheit"
    },
    "setpassword": {
        "passwortZuruecksetzen": "Passwort zurücksetzen",
        "resetText": "Legen Sie ein neues Passwort fest. Danach melden Sie sich mit Ihrer E-Mail-Adresse und dem neuen Passwort an.",
        "neuesPasswortFestlegen": "Neues Passwort festlegen",
        "linkUngueltig": "Link ungültig",
        "passwoerterStimmenNichtUeberein": "Die Passwörter stimmen nicht überein",
        "linkUngueltigOderAbgelaufen": "Der Link ist ungültig oder abgelaufen.",
        "linkAbgelaufen": "Der Link ist abgelaufen.",
        "linkAbgelaufenOderVerwendet": "Der Link ist abgelaufen oder wurde bereits verwendet.",
        "passwortZuSchwach": "Das Passwort ist zu schwach.",
        "fehlerAufgetreten": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
        "supportHinweis": "Bei technischen Problemen oder Fehlermeldungen senden Sie bitte eine E-Mail mit Screenshot und Beschreibung an support@caf-suite.ch.",
        "fuer": "für {{email}}",
        "gebenSieIhrNeuesPasswortEin": "Geben Sie Ihr neues Passwort ein.",
        "speichern": "Speichern...",
        "passwortSpeichern": "Passwort speichern",
        "einladungAnnehmen": "Einladung annehmen",
        "accountAktivierung": "Account Aktivierung",
        "willkommenBeiDer": "Willkommen bei der",
        "cafSuite": "CAF Suite.",
        "bitteLegenSieEinSicheres": "Bitte legen Sie ein sicheres Passwort fest, um Ihren Account zu aktivieren und Zugriff auf Ihre Organisation zu erhalten.",
        "passwortFestlegen": "Passwort festlegen",
        "erfolgreich": "Erfolgreich!",
        "ihrPasswortWurdeGespeichertSie": "Ihr Passwort wurde gespeichert. Sie werden in Kürze weitergeleitet...",
        "neuesPasswort": "Neues Passwort",
        "passwortBestaetigen": "Passwort bestätigen",
        "sichereSslVerschluesselung": "Sichere SSL-Verschlüsselung",
        "impressum": "Impressum",
        "datenschutz": "Datenschutz",
        "hilfe": "Hilfe",
        "privateDigital": "PRIVATE DIGITAL",
        "johannesSpring": "Johannes Spring",
        "voiaCumpogna1": "Voia Cumpogna 1",
        "schweiz": "Schweiz",
        "eMail": "E-Mail:",
        "haftungshinweisTrotzSorgfaeltigerInhaltlicherKontrolle": "Haftungshinweis: Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschliesslich deren Betreiber verantwortlich.",
        "datenschutzerklaerung": "Datenschutzerklärung",
        "hilfeSupport": "Hilfe & Support"
    },
    "superadmin": {
        "ausstehend": "Ausstehend",
        "ausstehendHinweis": "Eingeladen, Registrierung noch nicht abgeschlossen",
        "mandantGeloescht": "Mandant «{{name}}» wurde unwiderruflich gelöscht.",
        "fehlerLadenMandanten": "Fehler beim Laden der Mandanten.",
        "fehlerMandantAnlegen": "Beim Anlegen des Mandanten ist ein Fehler aufgetreten. Bitte prüfen Sie die Eingaben.",
        "zugriffVerweigert": "Zugriff verweigert.",
        "fehlerLadenBenutzer": "Fehler beim Laden der Benutzer.",
        "fehlerEinladen": "Fehler beim Einladen des Benutzers: {{msg}}",
        "rolleNichtGeaendert": "Die Rolle konnte nicht geändert werden.",
        "tenantAdminErnannt": "Benutzer \"{{email}}\" wurde zum Tenant-Admin ernannt.",
        "ich": "ICH",
        "backupHinweis": "Hier können die globalen Vorlagen (Kriterien, Methoden, Infos) exportiert und importiert werden. Nutzen Sie dies, um Daten vom Produktiv-System ins Test-System zu übertragen.",
        "backupHerunterladen": "Backup herunterladen (Export)",
        "backupHochladen": "Backup hochladen (Import)",
        "erstelle": "Erstelle...",
        "organisationenAnzahl": "Organisationen ({{count}})",
        "sperren": "Sperren",
        "aktivieren": "Aktivieren",
        "gesperrt": "Gesperrt",
        "registrierteAssessoren": "Registrierte Assessoren ({{count}})",
        "verwaltungMandant": "Verwaltung: {{name}}",
        "rolleAdmin": "Admin",
        "alsTenantAdminBenennen": "Als Tenant-Admin benennen",
        "emailPlatzhalterAdmin": "admin@firma.ch",
        "emailPlatzhalterNeu": "neu@firma.ch",
        "benutzerExistiertText": "Der Benutzer mit der E-Mail-Adresse <strong>{{email}}</strong> ist bereits im System registriert (evtl. in einer anderen Rolle oder einem anderen Mandanten).",
        "loesungText": "<strong>Lösung:</strong> Bitte nutzen Sie die \"Bearbeiten\"-Funktion in der Liste, um Rollen anzupassen, anstatt eine neue Einladung zu senden.",
        "benutzerEntfernenFrage": "Möchten Sie den Benutzer <strong>{{email}}</strong> wirklich aus diesem Mandanten entfernen?",
        "mandantLoeschenTitel": "ACHTUNG: Mandant \"{{name}}\" löschen?",
        "assessorLoeschenTitel": "ACHTUNG: Assessor \"{{email}}\" löschen?",
        "mandantLoeschenText": "Diese Aktion löscht den Mandanten <strong>inklusive aller Daten</strong> (Assessments, Massnahmen, Nutzer, Protokolle) unwiderruflich.",
        "alleBenutzerLoginsGeloescht": "Alle Benutzer-Logins werden gelöscht.",
        "alleBenutzerLoginsGeloeschtAnzahl": "Alle {{count}} Benutzer-Logins werden gelöscht.",
        "fremdbewertungenGeloeschtMarkiert": "Fremdbewertungen bei externen Assessoren werden als \"GELÖSCHT\" markiert.",
        "ok": "OK",
        "fehler": "Fehler",
        "systemAdministratoren": "System Administratoren",
        "datenManagementGlobal": "Daten-Management (Global)",
        "erfolg": "Erfolg",
        "nameAdmin": "Name Admin",
        "keineMandantenGefunden": "Keine Mandanten gefunden.",
        "externeBeraterOhneEigeneOrganisation": "Externe Berater ohne eigene Organisation",
        "keineExternenAssessorenGefunden": "Keine externen Assessoren gefunden.",
        "nameEMail": "Name / E-Mail",
        "firma": "Firma",
        "status": "Status",
        "aktionen": "Aktionen",
        "benutzerHinzufuegen": "Benutzer hinzufügen",
        "eMail": "E-Mail",
        "name": "Name",
        "rolle": "Rolle",
        "einladungErfolgreich": "Einladung erfolgreich!",
        "link": "Link:",
        "linkKopieren": "Link kopieren",
        "vorhandeneBenutzer": "Vorhandene Benutzer",
        "ladeBenutzer": "Lade Benutzer...",
        "keineBenutzerGefunden": "Keine Benutzer gefunden.",
        "user": "User",
        "benutzerBearbeiten": "Benutzer bearbeiten",
        "benutzer": "Benutzer",
        "abbrechen": "Abbrechen",
        "benutzerExistiertBereits": "Benutzer existiert bereits",
        "derBenutzerMitDerE": "Der Benutzer mit der E-Mail Adresse",
        "loesung": "Lösung:",
        "verstanden": "Verstanden",
        "moechtenSieDenBenutzer": "Möchten Sie den Benutzer",
        "dieseAktionLoeschtDenMandanten": "Diese Aktion löscht den Mandanten",
        "alleErstelltenAssessmentsGehenVerloren": "Alle erstellten Assessments gehen verloren.",
        "diesKannNichtRueckgaengigGemacht": "Dies kann nicht rückgängig gemacht werden.",
        "dieseAktionLoeschtDasAssessor": "Diese Aktion löscht das Assessor-Konto und den persönlichen Workspace vollständig.",
        "derLoginWirdUngueltig": "Der Login wird ungültig.",
        "lokalGespeicherteEntwuerfeWerdenGeloescht": "Lokal gespeicherte Entwürfe werden gelöscht.",
        "derAssessorWirdAusAllen": "Der Assessor wird aus allen Mandanten-Listen entfernt.",
        "musterfirmaAg": "Musterfirma AG",
        "maxMustermann": "Max Mustermann",
        "suchen": "Suchen...",
        "benutzerVerwalten": "Benutzer verwalten",
        "mandantUnwiderruflichLoeschenDangerZone": "Mandant unwiderruflich löschen (Danger Zone)",
        "assessorUnwiderruflichLoeschenDangerZone": "Assessor unwiderruflich löschen (Danger Zone)",
        "bearbeiten": "Bearbeiten",
        "loeschen": "Löschen",
        "benutzerLoeschen": "Benutzer löschen",
        "tenantList": "Mandanten Liste",
        "assessorList": "Assessor Liste",
        "userList": "Benutzer Liste",
        "roleMember": "Person des Mandanten (Fachrollen vergibt der Tenant Admin)",
        "roleTenantAdmin": "Tenant-Admin (Struktur, Personen, Einstellungen)"
    },
    "usermanagement": {
        "einladungAusstehend": "Einladung ausstehend",
        "ladenFehlgeschlagen": "Laden fehlgeschlagen",
        "externerAssessor": "Externer Assessor",
        "schliessen": "Schliessen",
        "benutzerExistiertBereits": "Benutzer existiert bereits",
        "derBenutzerMitDerE": "Der Benutzer mit der E-Mail Adresse",
        "tipp": "Tipp:",
        "verstanden": "Verstanden",
        "assessorNichtGefunden": "Assessor nicht gefunden",
        "wirKonntenKeinenRegistriertenAssessor": "Wir konnten keinen registrierten Assessor mit der E-Mail Adresse",
        "hinweis": "Hinweis:",
        "benutzerBearbeiten": "Benutzer bearbeiten",
        "zugriffEntfernen": "Zugriff entfernen",
        "ausMandantEntfernen": "Aus Mandant entfernen",
        "dieEmail": "Die E-Mail-Adresse",
        "esWurdeKeinAssessorMitDerEmail": "Wir konnten keinen registrierten Assessor mit der E-Mail-Adresse"
    },
    "richTextEditor": {
        "bold": "Fett",
        "italic": "Kursiv",
        "bulletList": "Aufzählung"
    },
    "kanbanboard": {
        "wipLimitReachedIntro": "Das konfigurierte WIP-Limit für die Spalte \"{{column}}\" ist in folgenden Kapazitäts-Töpfen bereits erreicht:",
        "wipLimitBottleneckHint": "Das zusätzliche Verschieben von Massnahmen führt erfahrungsgemäss zu Engpässen und Verzögerungen bei laufenden Aufgaben.",
        "wipLimitConfirmQuestion": "Möchten Sie diese Massnahme aufgrund dringlicher Prioritäten <strong>trotzdem</strong> in Arbeit nehmen?",
        "promise": "Promise",
        "kapazitaetsauslastung": "Kapazitätsauslastung",
        "ungueltigeVerantwortlichkeit": "Verantwortlichkeit ungültig",
        "wipLimitUeberschritten": "WIP-Limit überschritten",
        "abbrechen": "Abbrechen",
        "trotzdemFortfahren": "Trotzdem fortfahren",
        "dieserBenutzerIstNichtTeil": "Dieser Benutzer ist nicht Teil des Projektteams"
    },
    "projectcategoryselect": {
        "ownGroup": "Eigene Kategorien",
        "topicGroup": "Querschnittsthemen",
        "ownerUnknown": "zuständige Einheit",
        "topicLocked": "Querschnittsthemen ordnet das Portfoliomanagement der Herkunftseinheit zu.",
        "visibleFor": "sichtbar für {{unit}}",
        "sharedWith": "Durch Querschnittsthemen sichtbar für: {{units}} (Projektdaten und Risiken, ohne Massnahmen)",
        "keineKategorie": "Keine Kategorie",
        "keineKategorienGefunden": "Keine Kategorien gefunden",
        "searchCategory": "Kategorien suchen..."
    },
    "projectriskstab": {
        "schaden": "Schaden:",
        "wahrsch": "Wahrsch.:",
        "score": "Score:"
    },
    "projectroadmap": {
        "unbenannt": "Unbenannt",
        "meilenstein": "Meilenstein: {{title}}",
        "keineProjekteFuerRoadMap": "Keine Projekte für Road Map gefunden.",
        "sortierenNach": "Sortieren nach:",
        "ohneKategorie": "Ohne Kategorie",
        "ohneDatum": "Ohne Datum",
        "showCategories": "Kategorien einblenden",
        "hideCategories": "Kategorien ausblenden",
        "sortAlphabetical": "Alphabetisch",
        "sortStartDate": "Startdatum",
        "sortEndDate": "Enddatum"
    },
    "projectsettings": {
        "sie": "Sie",
        "feldnamePlaceholder": "z.B. Priorität, Kosten...",
        "bucketNamePlaceholder": "z.B. Grossprojekte",
        "wipLimitUmschalten": "WIP-Limit ein- oder ausschalten",
        "entfernenHinweis": "Wenn Sie ihn entfernen, bleiben diese Massnahmen vorerst bei ihm, er wird jedoch farblich als \"Ungültige Verantwortlichkeit\" markiert. Die Massnahmen sollten im Nachgang einem anderen Projektmitglied zugewiesen werden.",
        "promise": "Promise",
        "projektEinstellungen": "Projekt-Einstellungen",
        "mitglieder": "Mitglieder",
        "labels": "Labels",
        "projektMitglieder": "Projekt-Mitglieder",
        "verantwortlich": "Verantwortlich",
        "projektLabels": "Projekt-Labels",
        "definierenSieProjektweiteLabelsDie": "Definieren Sie projektweite Labels, die Tasks zur besseren Strukturierung zugewiesen werden können.",
        "neuesLabelErstellen": "Neues Label erstellen",
        "hinzufuegen": "Hinzufügen",
        "verfuegbareLabels": "Verfügbare Labels",
        "labelsWerdenGeladen": "Labels werden geladen...",
        "keineLabelsDefiniert": "Keine Labels definiert.",
        "pflicht": "Pflicht",
        "keineBucketsDefiniert": "Keine Buckets definiert.",
        "bucketName": "Bucket Name",
        "aufwandgroessenTShirt": "Aufwandgrössen (T-Shirt)",
        "taskGroupsTitle": "Massnahmengruppen",
        "taskGroupsDescription": "Gruppieren Sie Massnahmen in Phasen oder Ziele (z.B. Phase 1, Phase 2). Diese Gruppen können auf der Roadmap visualisiert werden.",
        "addGroup": "+ Gruppe hinzufügen",
        "groupName": "Gruppen-Name (z.B. Phase 1)",
        "groupDeleteWarning": "Achtung: Massnahmen in dieser Gruppe werden der Gruppe 'Keine' zugewiesen.",
        "wipLimit": "WIP-Limit",
        "achtungOffeneMassnahmen": "Achtung: Offene Massnahmen",
        "dieserBenutzerHatNoch": "Dieser Benutzer hat noch",
        "moechtenSieDenBenutzerTrotzdem": "Möchten Sie den Benutzer trotzdem entfernen?",
        "abbrechen": "Abbrechen",
        "trotzdemEntfernen": "Trotzdem entfernen",
        "labelNameZBBug": "Label-Name (z.B. Bug, Feature, Wichtig)",
        "labelFarbeWaehlen": "Label-Farbe wählen",
        "labelLoeschen": "Label löschen",
        "feldAktivieren": "Feld aktivieren",
        "pflichtfeld": "Pflichtfeld",
        "feldEntfernen": "Feld entfernen",
        "loeschen": "Löschen",
        "zugewiesen": "zugewiesen."
    },
    "projecttaskmanagement": {
        "neueAufgabe": "Neue Aufgabe",
        "aufgabeHinzufuegen": "+ Aufgabe hinzufügen",
        "promise": "Promise",
        "timelineGanttAnsicht": "Timeline / Gantt Ansicht",
        "dieseAnsichtWirdInEinem": "Diese Ansicht wird in einem zukünftigen Update ausgebaut. Sie wird es ermöglichen, Aufgaben grafisch auf einer Zeitachse zu planen und Abhängigkeiten zu visualisieren.",
        "liste": "Liste",
        "board": "Board",
        "timeline": "Timeline"
    },
    "risk": {
        "promise": "Promise"
    },
    "taskdetail": {
        "commentsLoadError": "Fehler beim Laden der Kommentare.",
        "commentDeleteError": "Der Kommentar konnte nicht gelöscht werden.",
        "unknownUser": "Unbekannte Person",
        "allProjectMembers": "Alle Projektmitglieder",
        "kommentarWirklichLoeschen": "Kommentar wirklich löschen?",
        "keineAuswahl": "– Keine Auswahl –",
        "status": "Status",
        "promise": "Promise",
        "ungueltigeVerantwortlichkeit": "Verantwortlichkeit ungültig",
        "dieAktuellZugewiesenePersonIst": "Die aktuell zugewiesene Person ist nicht Teil des Projektteams. Bitte weisen Sie die Massnahme einem gültigen Projektmitglied zu.",
        "beschreibung": "Beschreibung",
        "checkliste": "Checkliste",
        "verantwortlich": "Verantwortlich",
        "startdatum": "Startdatum",
        "faelligkeitsdatum": "Fälligkeitsdatum",
        "erinnerungsdatum": "Erinnerungsdatum",
        "massnahmengruppe": "Massnahmengruppe",
        "keineGruppe": "Keine Gruppe",
        "kommentareVerlauf": "Kommentare & Verlauf",
        "ladeKommentare": "Lade Kommentare...",
        "keineKommentareVorhanden": "Keine Kommentare vorhanden.",
        "worumGehtEs": "Worum geht es?",
        "aufDemKanbanBoardAnzeigen": "Auf dem Kanban-Board anzeigen",
        "detaillierteBeschreibungDerAufgabe": "Detaillierte Beschreibung der Aufgabe...",
        "neuerEintrag": "Neuer Eintrag...",
        "loeschen": "Löschen",
        "neueAufgabeErstellen": "Neue Aufgabe erstellen",
        "aufgabeBearbeiten": "Aufgabe bearbeiten",
        "titelDerAufgabe": "Titel der Aufgabe",
        "schliessen": "Schliessen",
        "abbrechen": "Abbrechen",
        "wirdGespeichert": "Wird gespeichert...",
        "aufgabeSpeichern": "Aufgabe speichern",
        "neuenKommentarSchreiben": "Neuen Kommentar schreiben... (@ Name tippen)",
        "sendError": "Fehler beim Senden des Kommentars",
        "nichtGeschaetzt": "Nicht geschätzt",
        "sKlein": "S (Klein)",
        "mMittel": "M (Mittel)",
        "lGross": "L (Gross)",
        "xlSehrGross": "XL (Sehr gross)",
        "checkliste.eintragErledigt": "Eintrag als erledigt markieren",
        "checkliste.eintragTitel": "Titel des Checklisteneintrags",
        "checkliste.entfernen": "Checklisteneintrag entfernen"
    },
    "tasklabelselect": {
        "wirdErstellt": "Wird erstellt...",
        "labelErstellen": "Label \"{{name}}\" erstellen",
        "farbeAuswaehlen": "Farbe {{color}} auswählen",
        "promise": "Promise",
        "keineLabelsGefunden": "Keine Labels gefunden.",
        "neuesLabelErstellen": "Neues Label erstellen",
        "labelsAuswaehlen": "Labels auswählen..."
    },
    "tasklist": {
        "unbenannteMassnahme": "Unbenannte Massnahme",
        "promise": "Promise",
        "massnahmenTasks": "Massnahmen (Tasks)",
        "nochKeineMassnahmenDefiniert": "Noch keine Massnahmen definiert.",
        "nichtZugewiesen": "Nicht zugewiesen",
        "ungueltig": "Verantwortlichkeit ungültig",
        "dieserBenutzerIstNichtTeil": "Dieser Benutzer ist nicht Teil des Projektteams",
        "loeschen": "Löschen",
        "columns": {
            "title": "Massnahme",
            "status": "Status",
            "dueDate": "Zieldatum",
            "assignee": "Verantwortlich",
            "checkbox": "Status",
            "actions": "Aktionen"
        },
        "toggleStatus": "Status umschalten"
    },
    "taskroadmap": {
        "verschieben": "Reihenfolge ändern",
        "meilenstein": "Meilenstein: {{title}}",
        "keineMassnahmenFuerZeitleisteGefunden": "Keine Massnahmen für Zeitleiste gefunden.",
        "sortierenNach": "Sortieren nach:",
        "ohneLabel": "Ohne Label",
        "ohneDatum": "Ohne Datum",
        "ohneGruppe": "Ohne Gruppe",
        "gruppierenNach": "Gruppieren nach:",
        "keine": "Keine",
        "massnahmengruppe": "Massnahmengruppe",
        "hideGroups": "Gruppierung ausblenden",
        "showGroups": "Gruppierung einblenden",
        "hideLabels": "Labels ausblenden",
        "showLabels": "Labels einblenden",
        "sortAlphabetical": "Alphabetisch",
        "sortStartDate": "Startdatum",
        "sortEndDate": "Enddatum"
    },
    "assessmentchart": {
        "punkte": "Punkte",
        "keineDatenVerfuegbar": "Keine Daten verfügbar."
    },
    "cafinteractivemodel": {
        "befaehiger": "Befähiger",
        "ergebnisse": "Ergebnisse"
    },
    "createproject": {
        "promise": "Promise",
        "neuesProjektErstellen": "Neues Projekt erstellen",
        "aiTitelVorschlagen": "AI Titel vorschlagen",
        "projektbewertungPriorisierung": "Projektbewertung & Priorisierung",
        "gesetzlicherAuftrag": "Gesetzlicher Auftrag",
        "istDiesesProjektZwingendUmzusetzen": "Ist dieses Projekt zwingend umzusetzen?",
        "abbrechen": "Abbrechen",
        "bitteWaehlen": "Bitte wählen...",
        "wirdErstellt": "Wird erstellt...",
        "projektErstellen": "Projekt erstellen"
    },
    "dangerconfirmation": {
        "zurBestaetigungTippenSieBitte": "Zur Bestätigung tippen Sie bitte",
        "grossUndKleinschreibungMussBeachten": "Gross- und Kleinschreibung muss beachten werden.",
        "abbrechen": "Abbrechen",
        "loeschen": "Löschen...",
        "endgueltigLoeschen": "Endgültig löschen"
    },
    "deleteconfirmation": {
        "loeschen": "Löschen..."
    },
    "errorboundary": {
        "error": "Error:"
    },
    "mfaverification": {
        "promise": "Promise",
        "close": "Schliessen",
        "code": "Code"
    },
    "notificationbell": {
        "benachrichtigungen": "Benachrichtigungen",
        "alleAlsGelesenMarkieren": "Alle als gelesen markieren",
        "keineBenachrichtigungenVorhanden": "Keine Benachrichtigungen vorhanden."
    },
    "notifications": {
        "reminder": "Erinnerung",
        "mention": "Neue Erwähnung",
        "reorganization": "Einheit verschoben"
    },
    "permissionselection": {
        "berechtigungsLevelAuswaehlen": "Rolle & Berechtigung auswählen",
        "waehlenSieDieZutreffendeRolle": "Wählen Sie die Fachrolle für diesen Benutzer in seiner Organisationseinheit.",
        "roleSelectionTitle": "Rolle & Berechtigung auswählen",
        "roleSelectionSubtitle": "Wählen Sie die Fachrolle für diesen Benutzer in seiner Organisationseinheit.",
        "roles": {
            "qm_management": {
                "title": "QM-Management",
                "description": "Erstellt, dupliziert, löscht und gibt CAF-Bewertungen frei. Führt die strategische Projektpriorisierung durch und steuert die Weitergabe von Informationen an übergeordnete Ebenen.",
                "descriptionV2": "Verantwortet die CAF-Selbstbewertung der Einheit: erstellt, schliesst ab und gibt an die übergeordnete Einheit frei. Sieht die freigegebenen Bewertungen der unterstellten Einheiten."
            },
            "management": {
                "title": "Management",
                "description": "Vollständige Einsicht in alle Projekte der Einheit. Wirkt aktiv an der aktuellen CAF-Selbsteinschätzung mit (erfasst Scores, Stärken und Potenziale).",
                "descriptionV2": "Leitung der Einheit. Wirkt an der CAF-Bewertung mit und hat Leserechte auf alle CAF- und Portfoliodaten der Einheit."
            },
            "project_management": {
                "title": "Projektleitung",
                "description": "Operative Leitung eigener Projekte. Verwaltet Projektdetails, Meilensteine, Risiken, Ampelstatus und Massnahmen.",
                "descriptionV2": "Erstellt Projekte und leitet eigene Projekte (Details, Risiken, Massnahmen)."
            },
            "project_team": {
                "title": "Projektmitwirkung",
                "description": "Bearbeitet zugewiesene Massnahmen und Aufgaben (Status aktualisieren, Checklisten abhaken, Kommentare verfassen).",
                "descriptionV2": "Bearbeitet zugewiesene Massnahmen in Projekten, in denen die Person mitwirkt."
            },
            "portfolio_management": {
                "title": "Portfoliomanagement",
                "description": "Steuert das Projektportfolio der Einheit: priorisiert, bewertet, gibt Projekte an die übergeordnete Einheit weiter und ordnet Querschnittsthemen zu."
            }
        },
        "addons": {
            "isOrgAdmin": {
                "title": "Org-Admin",
                "description": "Berechtigt den Benutzer, Kollegen innerhalb der eigenen Organisationseinheit einzuladen und zu verwalten."
            },
            "isTenantAdmin": {
                "title": "Tenant-Admin",
                "description": "Verwaltet die N-Level Organisationsstruktur, globale Einstellungen und ernennt Org-Admins.",
                "descriptionV2": "Verwaltet Organisationsstruktur, Personen, Einstellungen und Querschnittsthemen. Sieht keine Inhalte fremder Einheiten."
            }
        },
        "levels": {
            "50": {
                "title": "Tenant-Admin",
                "description": "Verwaltet die Organisationsstruktur, globale Einstellungen und ernennt Org-Admins."
            },
            "40": {
                "title": "QM-Management",
                "description": "CAF-Bewertungen erstellen, freigeben und löschen. Strategische Projektpriorisierung."
            },
            "30": {
                "title": "Management",
                "description": "Aktive Mitwirkung an CAF-Bewertungen und vollständige Einsicht in alle Projekte der Einheit."
            },
            "20": {
                "title": "Projektleitung",
                "description": "Eigene Projekte, Risiken und Massnahmen leiten."
            },
            "10": {
                "title": "Projektmitwirkung",
                "description": "Zugewiesene Massnahmen und Aufgaben bearbeiten."
            }
        },
        "rolesSelectionTitle": "Fachrollen auswählen",
        "rolesSelectionSubtitle": "Die Rollen gelten in der Organisationseinheit der Person. Mehrere Rollen sind möglich.",
        "apply": "Übernehmen",
        "rolesTitle": "Fachrollen"
    },
    "principlesbubbles": {
        "grundsaetzeDerExzellenz": "Grundsätze der Exzellenz"
    },
    "privacycontent": {
        "allgemeines": "1. Allgemeines",
        "derSchutzIhrerDatenHat": "Der Schutz Ihrer Daten hat für uns höchste Priorität. Wir verarbeiten personenbezogene Daten ausschliesslich im Rahmen der gesetzlichen Bestimmungen (DSGVO, DSG).",
        "datenerhebungBeiNutzung": "2. Datenerhebung bei Nutzung",
        "wennSieUnsereSoftwareNutzen": "Wenn Sie unsere Software nutzen, erheben wir folgende Daten, die technisch erforderlich sind:",
        "ipAdresse": "IP-Adresse",
        "datumUndUhrzeitDerAnfrage": "Datum und Uhrzeit der Anfrage",
        "inhaltDerAnforderungKonkreteSeite": "Inhalt der Anforderung (konkrete Seite)",
        "browserUndBetriebssystem": "Browser und Betriebssystem",
        "benutzerkonten": "3. Benutzerkonten",
        "fuerDieNutzungDerApp": "Für die Nutzung der App ist ein Benutzerkonto erforderlich. Hierbei speichern wir Ihre E-Mail-Adresse, Ihren Namen (optional) sowie Ihre Zugehörigkeit zu einer Organisation (Mandant).",
        "ihreRechte": "4. Ihre Rechte",
        "ihreRechteText": "Sie haben das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung Ihrer gespeicherten Daten. Wenden Sie sich hierzu bitte an unseren Datenschutzbeauftragten unter datenschutz@caf-suite.ch.",
        "kiFunktionen": "5. KI-Funktionen (optional)",
        "kiFunktionenText": "Die CAF Suite bietet optionale KI-Funktionen, etwa Vorschläge für Projekte oder eine Management Summary. Ihre Organisation kann sie jederzeit ausschalten; dann werden keine Daten an den KI-Dienst übermittelt. Ist eine Funktion eingeschaltet, sendet die CAF Suite nur die Inhalte, die sie braucht (z.B. Werte und Bemerkungen einer Bewertung oder den Text eines Potenzials), an Google Vertex AI. Namen und E-Mail-Adressen der Benutzerkonten werden nicht übermittelt. Die Verarbeitung erfolgt in Rechenzentren in der EU, nicht in der Schweiz. Google verwendet die Daten nicht zum Training seiner Modelle, kann Anfragen aber zur Missbrauchserkennung protokollieren. Die Antworten speichert die CAF Suite nur, wenn Sie einen Vorschlag übernehmen.",
        "hinweisZurCloudNutzung": "6. Hinweis zur Cloud-Nutzung & Personendaten",
        "dieDatenWerdenInGoogle": "Die Daten werden in Google Cloud Rechenzentren (Zürich) gespeichert. Wir weisen darauf hin, dass bei Nutzung von US-Cloud-Anbietern theoretische Zugriffsrechte durch US-Behörden (Cloud Act) diskutiert werden.",
        "empfehlungDieseAppDientDer": "Empfehlung: Diese App dient der strategischen Organisationsanalyse (CAF). Bitte erfassen Sie keine sensiblen personenbezogenen Daten von Bürgerinnen und Bürgern (z.B. in Massnahmen oder Kommentaren). Dies ist für den Zweck der Anwendung nicht erforderlich."
    },
    "screenshotcarousel": {
        "bildNummer": "Bild {{number}}: {{title}}",
        "bildWirdSpaeterEingefuegt": "Bild wird später eingefügt",
        "vorherigesBild": "Vorheriges Bild",
        "naechstesBild": "Nächstes Bild"
    },
    "ssoconfigsection": {
        "fehlerKonfiguration": "Fehler bei der SSO-Konfiguration.",
        "fehlerEntfernen": "Fehler beim Entfernen der SSO-Konfiguration.",
        "clientIdPlaceholder": "z.B. 12345678-abcd-1234-abcd-1234567890ab",
        "issuerUrlPlaceholder": "z.B. https://login.microsoftonline.com/{tenant-id}/v2.0",
        "saml20": "SAML 2.0",
        "openidConnectOidc": "OpenID Connect (OIDC)",
        "clientId": "Client ID",
        "issuerUrl": "Issuer URL"
    },
    "assessmentwizard": {
        "durchschnitt": "Durchschnitt"
    },
    "clientselection": {
        "neuenBewertungErstellen": "Neuen Bewertung erstellen",
        "bitteWaehlenSieDenMandanten": "Bitte wählen Sie den Mandanten aus, für den Sie diese Bewertung erstellen möchten.",
        "keineAktivenMandantenGefunden": "Keine aktiven Mandanten gefunden.",
        "abbrechen": "Abbrechen"
    },
    "editremark": {
        "bemerkungBearbeiten": "Bemerkung bearbeiten",
        "text": "Text",
        "urlOptional": "URL (Optional)"
    },
    "exportcontent": {
        "pdfErstellen": "PDF erstellen",
        "generiere": "Generiere...",
        "inhalteAlsPdfExportieren": "Inhalte als PDF exportieren",
        "waehlenSieDieZuExportierenden": "Wählen Sie die zu exportierenden Inhalte aus.",
        "methodenbaukasten": "Methodenbaukasten",
        "themenfelderKriterien": "Themenfelder & Kriterien",
        "informationsbereiche": "Informationsbereiche",
        "abbrechen": "Abbrechen"
    },
    "methodeditor": {
        "titelPlatzhalter": "z.B. Leitbild-Workshop",
        "bitteWaehlen": "Bitte wählen...",
        "bildvorschau": "Bildvorschau",
        "formatHinweis": "Nutzen Sie Zeilenumbrüche für Strukturierung und <strong>**doppelte Sternchen**</strong> für Fettdruck.",
        "titel": "Titel",
        "zugehoerigesKriterium": "Zugehöriges Kriterium",
        "zielUndZweck": "Ziel und Zweck",
        "beschreibungDetails": "Beschreibung / Details",
        "bildOptional": "Bild (Optional)",
        "bildEntfernen": "Bild entfernen",
        "tippsHandlungsanleitung": "Tipps & Handlungsanleitung",
        "nutzenSieZeilenumbruecheFuerStrukturierung": "Nutzen Sie Zeilenumbrüche für Strukturierung und",
        "abbrechen": "Abbrechen",
        "kurzeBeschreibungDesZiels": "Kurze Beschreibung des Ziels...",
        "ausfuehrlicheBeschreibung": "Ausführliche Beschreibung...",
        "fettMarkieren": "Fett markieren",
        "schrittFuerSchrittAnleitung": "Schritt-für-Schritt Anleitung...",
        "methodeBearbeiten": "Methode bearbeiten",
        "neueMethodeErstellen": "Neue Methode erstellen",
        "laedt": "Lädt hoch...",
        "speichern": "Speichern"
    },
    "export": {
        "title": "Bericht exportieren",
        "question": "Welche Inhaltsabschnitte sollen eingeschlossen werden?",
        "overview": "Score-Übersicht",
        "overviewDesc": "Zusammenfassung der Scores je Themenfeld mit Spinnennetz-Diagramm.",
        "trendAnalysis": "Langzeit-Trendanalyse",
        "trendAnalysisDesc": "Entwicklung der Scores über mehrere Bewertungen hinweg.",
        "chartLoading": "Diagramm wird geladen...",
        "generating": "Wird generiert..."
    },
    "languageUnavailableModal": {
        "title": "Sprache nicht mehr verfügbar",
        "message": "Die von Ihnen gewählte Sprache wurde von Ihrem Administrator deaktiviert. Bitte wählen Sie eine der verfügbaren Sprachen, um fortzufahren.",
        "selectPrompt": "Verfügbare Sprachen:",
        "saving": "Speichern..."
    },

    "legal": {
        "impressum": "Impressum",
        "datenschutz": "Datenschutz",
        "nutzungsbedingungen": "Nutzungsbedingungen",
        "cookieRichtlinie": "Cookie-Richtlinie",
        "backToLogin": "Zurück zum Login",
        "termsTitle": "Nutzungsbedingungen (Terms of Service)",
        "termsGeneralTitle": "1. Geltungsbereich",
        "termsGeneralContent": "Diese Nutzungsbedingungen gelten für den Zugriff und die Nutzung der CAF Suite (nachfolgend \"Anwendung\"). Die Anwendung wird ausschliesslich für Geschäftskunden (B2B) bereitgestellt.",
        "termsContractTitle": "2. Vorrang des SaaS-Vertrags",
        "termsContractContent": "Die detaillierten Rechte, Pflichten, Haftungsfragen sowie datenschutzrechtlichen Vereinbarungen (inkl. Auftragsverarbeitungsvertrag) richten sich primär nach dem mit Ihrer Organisation geschlossenen individuellen Software-as-a-Service (SaaS) Vertrag. Bei offenen rechtlichen Fragen oder in Widerspruchsfällen gehen die schriftlich vereinbarten Bestimmungen dieses Hauptvertrags diesen Rahmenbedingungen stets vor.",
        "termsAccessTitle": "3. Autorisierter Zugang",
        "termsAccessContent": "Der Zugang zu dieser Instanz ist nur explizit berechtigten Mitarbeitenden der lizenzierten Organisationen sowie deren beauftragten Assessoren gestattet. Zugangsdaten dürfen unter keinen Umständen an Dritte weitergegeben werden.",
        "cookiePolicyTitle": "Cookie-Richtlinie",
        "cookieNoTrackingTitle": "1. Grundsatz: Kein Tracking",
        "cookieNoTrackingContent": "Wir respektieren Ihre Privatsphäre und die sensiblen Daten in dieser Anwendung vollumfänglich. Deshalb verwenden wir in der CAF Suite keine Marketing-, Analyse- oder Tracking-Cookies (wie z.B. Google Analytics). Es werden ausschliesslich technisch zwingend notwendige Mechanismen eingesetzt, um Kernfunktionen und die Systemsicherheit zu gewährleisten.",
        "cookieAuthTitle": "2. Authentifizierung & Sitzungsverwaltung",
        "cookieAuthContent": "Für die sichere Anmeldung und die Aufrechterhaltung Ihrer aktiven Sitzung werden verschlüsselte Session-Token (sog. JSON Web Tokens) in Ihrem Browser gespeichert (LocalStorage / IndexedDB). Diese Tokens sind sicherheitsrelevant und technisch zwingend erforderlich, damit Ihr Login während der Benutzung nicht sofort abläuft.",
        "cookieCloudflareTitle": "3. Cloudflare Turnstile (Bot-Prävention)",
        "cookieCloudflareContent": "Zum Schutz der sensiblen Login-Masken vor automatisierten Brute-Force-Angriffen nutzen wir Cloudflare Turnstile. Dieser Dienst wertet im Hintergrund rein technische Browser-Metadaten aus, verzichtet dabei aber vollumfänglich auf geräteübergreifendes Benutzer-Tracking und setzt dezidiert keine Tracking-Cookies."
    },
    "cookies": {
        "bannerText": "Wir verwenden ausschliesslich technisch zwingend notwendige Cookies und Storage-Mechanismen (z.B. für Login-Sitzungen), um die Sicherheit und Funktionsfähigkeit dieser Plattform zu gewährleisten. Es werden keine Tracking- oder Marketing-Cookies eingesetzt.",
        "bannerTitle": "Cookie-Hinweis",
        "accept": "Verstanden",
        "policyLink": "Mehr erfahren"
    },
    "localizedFields": {
        "language": "Sprache",
        "hint": "Mindestens eine Sprache ausfüllen. Wo eine Sprache fehlt, erscheint der Text der ersten ausgefüllten Sprache."
    },
    "tenantLock": {
        "unlock": "Entsperren",
        "lockDialog": {
            "title": "Mandant «{{name}}» sperren?",
            "intro": "Gesperrt heisst: kein Zugriff für die Personen dieses Mandanten.",
            "signOut": "Alle Personen des Mandanten werden abgemeldet und können sich nicht mehr anmelden.",
            "assessors": "Externe Assessoren können keine Bewertungen mehr an diesen Mandanten einreichen.",
            "noInvites": "Es lassen sich keine Personen und keine Assessoren mehr hinzufügen.",
            "dataKept": "Die Daten bleiben erhalten. Sie können sie weiterhin exportieren.",
            "reversible": "Entsperren stellt den Zugang wieder her.",
            "confirm": "Mandant sperren"
        },
        "unlockDialog": {
            "title": "Mandant «{{name}}» entsperren?",
            "message": "Die Personen des Mandanten können sich wieder anmelden und erhalten ihren bisherigen Zugriff. Konten, die schon vor der Sperre deaktiviert waren, bleiben deaktiviert.",
            "confirm": "Mandant entsperren"
        },
        "result": {
            "lockedTitle": "Mandant «{{name}}» gesperrt",
            "unlockedTitle": "Mandant «{{name}}» entsperrt",
            "unlockIncompleteTitle": "Mandant «{{name}}» bleibt gesperrt",
            "people": "Personen des Mandanten: {{n}}",
            "disabled": "Anmeldekonten deaktiviert: {{n}}",
            "enabled": "Anmeldekonten wieder aktiviert: {{n}}",
            "skipped": "Ohne Anmeldekonto übersprungen: {{n}}",
            "lockErrors": "Konten, die sich nicht deaktivieren liessen: {{n}}. Diese Personen haben trotzdem keinen Zugriff auf Daten. Details stehen in Cloud Logging.",
            "unlockErrors": "Konten, die sich nicht wieder aktivieren liessen: {{n}}. Der Mandant bleibt gesperrt. Bitte entsperren Sie ihn erneut; Details stehen in Cloud Logging."
        },
        "export": {
            "action": "Daten exportieren",
            "running": "Daten werden exportiert …",
            "failedTitle": "Export fehlgeschlagen",
            "noLink": "Der Export hat keinen Download-Link geliefert. Bitte versuchen Sie es erneut."
        },
        "page": {
            "title": "Mandant gesperrt",
            "message": "Ihr Mandant ist gesperrt. Sie haben keinen Zugriff mehr auf die CAF Suite; Ihre Daten bleiben erhalten. Bitte wenden Sie sich an Ihre Organisation oder an den Support.",
            "logout": "Abmelden"
        },
        "loginDisabled": "Ihr Konto ist deaktiviert, zum Beispiel weil Ihr Mandant gesperrt ist. Bitte wenden Sie sich an Ihre Organisation oder an den Support."
    },
    "orgTree": {
        "title": "Organisationsstruktur",
        "subtitle": "Hierarchische Verwaltung aller Organisationseinheiten (N-Level)",
        "addChildUnit": "Untergeordnete Einheit anlegen",
        "unitName": "Bezeichnung der Einheit",
        "unitCode": "Kürzel",
        "headcountFTE": "Vollzeitäquivalente (FTE)",
        "portfolioManagers": "Projektportfoliomanager (PPM)",
        "unitLeads": "Leitung der Einheit",
        "reparentSubtree": "Einheit verschieben",
        "newParent": "Neue übergeordnete Einheit",
        "confirmDelete": "Organisationseinheit wirklich löschen?",
        "deleteWarning": "Es dürfen keine untergeordneten Einheiten oder aktiven Projekte mehr verknüpft sein.",
        "fetchError": "Fehler beim Laden der Organisationsstruktur.",
        "breadcrumbAriaLabel": "Organisationspfad",
        "assignedOrgUnit": "Zugeordnete Organisationseinheit",
        "selectOrgUnit": "Organisationseinheit auswählen...",
        "sharingScope": "Sichtbarkeit / Freigabe-Umfang",
        "sharingScopeUpward": "Inkl. übergeordnete Ebenen (CAF-Rollup)",
        "sharingScopeTenant": "Mandantenweit sichtbar",
        "sharingScopeParentOnly": "Nur direkte übergeordnete Ebene",
        "sharingScopeConfidential": "Vertraulich (Nur diese Einheit)",
        "noOrgUnitAssigned": "Keine Einheit zugeordnet (Mandantenweit)",
        "createdAnnounce": "Organisationseinheit erfolgreich erstellt.",
        "createError": "Fehler beim Erstellen.",
        "updatedAnnounce": "Organisationseinheit erfolgreich aktualisiert.",
        "updateError": "Fehler beim Aktualisieren.",
        "reparentedAnnounce": "Organisationseinheit erfolgreich verschoben.",
        "reparentError": "Fehler beim Verschieben.",
        "reactivatedAnnounce": "Organisationseinheit reaktiviert.",
        "deactivatedAnnounce": "Organisationseinheit deaktiviert.",
        "deletedAnnounce": "Organisationseinheit gelöscht.",
        "deleteError": "Fehler beim Löschen.",
        "inactive": "deaktiviert",
        "reactivate": "Reaktivieren",
        "deactivate": "Deaktivieren",
        "deleteHint": "Löschen (nur ohne Untereinheiten, Personen und Daten)",
        "subtitleLevels": "Hierarchie der Organisationseinheiten, höchstens {{max}} Ebenen.",
        "noUnitsFound": "Noch keine Organisationseinheiten angelegt.",
        "createChildUnder": "Neue Einheit unter \"{{parentName}}\"",
        "editUnitTitle": "Organisationseinheit bearbeiten",
        "unitCodePlaceholder": "z.B. AFI",
        "unitDescription": "Beschreibung",
        "reparentHelp": "Wählen Sie die neue übergeordnete Einheit für \"{{unitName}}\". Alle Untereinheiten werden mitverschoben.",
        "confirmReparent": "Verschieben",
        "addRootUnitV2": "Oberste Einheit anlegen",
        "missingLanguages": "{{languages}} fehlt",
        "insertRoot": "Übergeordnete Einheit einfügen",
        "insertRootHint": "Neue oberste Einheit über dieser einfügen, z.B. wenn ein Departement Teil des ganzen Kantons wird",
        "insertRootFull": "Die Struktur hat bereits {{max}} Ebenen.",
        "removeRoot": "Oberste Einheit entfernen",
        "confirmRemoveRoot": "«{{root}}» entfernen? «{{child}}» wird wieder oberste Einheit und gibt dem Mandanten den Namen. Das geht nur, solange «{{root}}» niemand zugeordnet und nichts freigegeben oder weitergegeben wurde.",
        "rootInsertedAnnounce": "Übergeordnete Einheit eingefügt.",
        "insertRootError": "Die Einheit konnte nicht eingefügt werden.",
        "rootRemovedAnnounce": "Oberste Einheit entfernt.",
        "removeRootError": "Die oberste Einheit konnte nicht entfernt werden.",
        "previewError": "Die Folgen konnten nicht ermittelt werden.",
        "previewLoading": "Folgen werden ermittelt …",
        "noConsequences": "Es werden keine Freigaben und keine Weitergaben aufgelöst.",
        "subunitsMoved_one": "1 Untereinheit wird mitverschoben.",
        "subunitsMoved_other": "{{count}} Untereinheiten werden mitverschoben.",
        "irreversibleTitle": "Folgendes kann nicht rückgängig gemacht werden:",
        "releasesWithdrawn_one": "1 freigegebene Bewertung ({{years}}) an «{{parent}}» wird zurückgezogen. «{{parent}}» sieht sie nicht mehr, auch nicht in den Auswertungen früherer Jahre.",
        "releasesWithdrawn_other": "{{count}} freigegebene Bewertungen ({{years}}) an «{{parent}}» werden zurückgezogen. «{{parent}}» sieht sie nicht mehr, auch nicht in den Auswertungen früherer Jahre.",
        "consequencesKept": "Bestehen bleiben: alle Daten der Einheit, Querschnittsthemen und Freigaben innerhalb des verschobenen Bereichs. Die Einheit kann Bewertungen und Projekte der neuen übergeordneten Einheit erneut freigeben bzw. weitergeben; ihr QM-Management und Portfoliomanagement werden benachrichtigt.",
        "confirmConsequences": "Ich habe die Folgen verstanden.",
        "insertRootIntro": "Die neue Einheit wird über «{{root}}» eingefügt, zum Beispiel wenn ein Departement Teil des ganzen Kantons wird.",
        "new": "neu",
        "subunitsCount_one": "1 Untereinheit wie bisher",
        "subunitsCount_other": "{{count}} Untereinheiten wie bisher",
        "insertRootNothingRevoked": "Es wird keine Freigabe und keine Weitergabe aufgelöst. Alle Einheiten behalten ihre Personen, Bewertungen und Projekte.",
        "insertRootReleaseLater": "«{{root}}» kann Bewertungen und Projekte danach «{{name}}» freigeben bzw. weitergeben.",
        "insertRootLevels": "Die Struktur hat danach {{levels}} Ebenen (höchstens {{max}}).",
        "insertRootTenantName": "Der Mandant heisst danach «{{name}}». Der Name der obersten Einheit ist immer auch der Name des Mandanten.",
        "insertRootAdmins": "Tenant-Admin-Rechte gelten für den ganzen Mandanten, also künftig für die ganze neue Organisation: alle Personen, die Struktur und den vollständigen Datenexport.",
        "insertRootAdminsToday": "Heute haben sie: {{names}}.",
        "insertRootAdminsCheck": "Prüfen Sie danach in der Benutzerverwaltung, wer sie haben soll.",
        "insertRootPeople": "Personen bleiben in ihrer Einheit. Der neuen obersten Einheit ist noch niemand zugeordnet.",
        "insertRootOperator": "Der Betreiber der CAF Suite wird über die Änderung informiert.",
        "insertRootUndo": "Rückgängig machen lässt sich das, solange der neuen Einheit niemand zugeordnet und nichts freigegeben oder weitergegeben wurde.",
        "rootNameIsTenantName": "Der Name der obersten Einheit ist zugleich der Name des Mandanten.",
        "unitDescriptionInternal": "Beschreibung (interne Notiz)",
        "reparentNamed": "«{{unitName}}» verschieben",
        "wizardSteps": "Schritte",
        "wizardStepName": "Name",
        "wizardStepPreview": "Vorschau",
        "wizardStepAdmin": "Verwaltung",
        "insertRootConfirm": "Einheit einfügen",
        "promotionsRevokedAt_one": "1 Projekt-Weitergabe wird aufgehoben (bisher bei {{units}}).",
        "promotionsRevokedAt_other": "{{count}} Projekt-Weitergaben werden aufgehoben (bisher bei {{units}})."
    },
    "governance": {
        "topicsVisibleFor": "Sichtbar für: {{list}}",
        "topicsWhere": "Querschnittsthemen ordnet das Portfoliomanagement der Herkunftseinheit im Feld «Kategorien» zu.",
        "stepperTitle": "Schlüsselprojekt-Kaskadierung (Promotion Pipeline)",
        "stepperSubtitle": "Stufenweise Weitergabe an übergeordnete Portfolios ohne automatische Eskalation",
        "stepperAriaLabel": "Hierarchie-Freigabepfad",
        "promotedSuccessAnnounce": "Projekt wurde an {{unitName}} freigegeben.",
        "revokedSuccessAnnounce": "Freigabe für {{unitName}} wurde zurückgezogen.",
        "promotedByOn": "Freigegeben durch {{name}} am {{date}}",
        "promoteAction": "Freigeben",
        "revokeAction": "Freigabe entziehen",
        "promoteModalTitle": "Projekt an übergeordnete Ebene melden",
        "promoteModalSubtitle": "Beförderung von \"{{from}}\" an \"{{to}}\"",
        "promotionCommentLabel": "Begründung / Hinweis für das übergeordnete Portfolio (optional)",
        "promotionCommentPlaceholder": "z.B. Erfüllt die Kriterien für Departementsschwerpunkt.",
        "confirmPromote": "Jetzt freigeben",
        "levelEvaluationTitle": "Strategische Bewertung: {{unitName}}",
        "levelEvaluationSubtitle": "Ebenenspezifische strategische Priorisierung für dieses Portfolio",
        "executiveVaultBadge": "Executive Vault (Vertraulich)",
        "originLevelScoringHint": "Auf dieser Ursprungsebene wird die strategische Priorisierung über die Hauptbewertung des Projekts (oben) gesteuert.",
        "strategicImportanceLabel": "Strategische Bedeutung auf dieser Ebene (1–10)",
        "benefitLabel": "Erwarteter Nutzen auf dieser Ebene (1–10)",
        "portfolioNotesLabel": "Vertrauliche Notiz / Briefing für dieses Führungsgremium",
        "portfolioNotesHelp": "Nur für Mitglieder dieser Organisationsebene sichtbar. Für Projektmitarbeitende unsichtbar.",
        "portfolioNotesPlaceholder": "z.B. Traktandieren für Ratssitzung: Zusatzkredit nötig.",
        "evaluationSavedAnnounce": "Ebenenbewertung erfolgreich gespeichert.",
        "promoteError": "Fehler bei der Projekt-Beförderung.",
        "revokeError": "Fehler beim Zurückziehen der Freigabe.",
        "evaluateError": "Fehler beim Speichern der Bewertung.",
        "promotedAnnounce": "Projekt an {{unit}} weitergegeben.",
        "revokedAnnounce": "Weitergabe zurückgezogen.",
        "actionError": "Aktion fehlgeschlagen.",
        "origin": "Herkunft",
        "promotedAtBy": "{{date}} · {{name}}",
        "title": "Weitergabe & Querschnittsthemen",
        "subtitle": "Übergeordnete Einheiten und Querschnittsämter sehen das Projekt mit Risiken, aber ohne Massnahmen, und bearbeiten es nicht.",
        "chain": "Weitergabekette",
        "notPromoted": "nicht weitergegeben",
        "promoteTo": "An {{unit}} weitergeben",
        "revoke": "Weitergabe zurückziehen",
        "topicsTitle": "Querschnittsthemen",
        "promoteExplain": "{{unit}} sieht das Projekt danach mit Projektdaten und Risiken (ohne Massnahmen) und kann es selbst bewerten oder weitergeben.",
        "comment": "Begründung (optional)",
        "revokeExplain": "Ihre Weitergabe und alle Weitergaben darüber werden zurückgezogen. Die betroffenen Einheiten sehen das Projekt danach nicht mehr.",
        "confirm": "Bestätigen"
    },
    "rollup": {
        "dashboardTitle": "CAF Rollup & Konsolidierung: {{unitName}}",
        "dashboardSubtitle": "Aggregierte Auswertung über {{count}} Selbstevaluationen aus {{units}} Organisationseinheiten",
        "weightedFteToggle": "Mitarbeiter-Gewichtung (FTE)",
        "viewModeLabel": "Ansicht wechseln",
        "chartView": "Spinnendiagramm",
        "tableView": "Tabelle (Barrierefrei)",
        "loadedAnnounce": "Rollup-Daten erfolgreich aktualisiert.",
        "noAssessmentsFound": "Keine freigegebenen Assessments im Unterbaum dieser Organisationseinheit gefunden.",
        "radarChartTitle": "Konsolidiertes Kriterienprofil (CAF Reifegrad)",
        "rollupAverage": "Konsolidierter Durchschnitt",
        "averageScore": "Durchschnitt",
        "insightsTitle": "Querschnitts-Erkenntnisse",
        "insightsSubtitle": "Musterhafte Stärken und Abweichungen über alle untergeordneten Ämter",
        "topStrengthBadge": "Grösste Stärke",
        "topPotentialBadge": "Grösstes Entwicklungspotenzial",
        "totalRemarksCount": "{{count}} qualitative Befunde (Stärken & Potenziale) aggregiert",
        "tableCaption": "CAF Rollup Kennzahlen nach Subkriterien",
        "subCriterionCol": "Subkriterium",
        "averageCol": "Mittelwert",
        "minCol": "Min",
        "maxCol": "Max",
        "varianceCol": "Spannweite (Δ)",
        "assessmentsCountCol": "Anzahl",
        "childUnits": "unterstellten Einheiten",
        "titleV2": "{{unit}}: Aggregat der {{children}}",
        "explain": "Pro Einheit zählt das letzte abgeschlossene und an Ihre Einheit freigegebene Assessment des Jahres; fehlt eines, das letzte davor. Jede Einheit zählt gleich viel; nicht bewertete Subkriterien zählen nicht.",
        "year": "Jahr",
        "coverage": "Abdeckung: {{included}} von {{total}} {{children}}",
        "unitsCaption": "Einbezogene Einheiten",
        "unitCol": "Einheit",
        "assessmentCol": "Assessment",
        "totalCol": "Gesamtwert",
        "carriedOver": "übernommen aus {{year}}",
        "notIncluded": "nicht enthalten (kein freigegebenes Assessment)",
        "noChildUnits": "Diese Einheit hat keine unterstellten Einheiten.",
        "radarTitle": "Durchschnitt pro Kriterium",
        "totalMean": "Gesamt {{value}} %",
        "average": "Durchschnitt",
        "insights": "Auffälligkeiten",
        "strongest": "Höchster Durchschnitt",
        "weakest": "Tiefster Durchschnitt",
        "trend": "Verlauf Gesamtwert",
        "total": "Gesamt",
        "subCriteriaTitle": "Subkriterien",
        "spreadCol": "Streuung (σ)",
        "nCol": "Einheiten",
        "remarksTitle": "Bemerkungen der Einheiten",
        "remarkFilter": "Art der Bemerkung",
        "potentials": "Potenziale",
        "strengths": "Stärken",
        "allRemarks": "Alle",
        "noRemarks": "Keine Bemerkungen.",
        "noAssessmentsFoundV2": "Für dieses Jahr liegen keine freigegebenen Assessments der {{children}} vor."
    },
    "unitView": {
        "statuses": { "TOP_PRIORITY": "Top-Priorität", "ACTIVE": "Aktiv", "WATCHLIST": "Beobachtung", "DEPRIORITIZED": "Zurückgestellt" },
        "categories": "Eigene Kategorien",
        "savedAnnounce": "Bewertung gespeichert.",
        "title": "Sicht {{unit}}",
        "confidential": "Vertraulich: nur für Ihre Einheit sichtbar. Die Herkunftseinheit und andere Ebenen sehen diese Angaben nicht.",
        "rank": "Rang",
        "status": "Status im Portfolio",
        "statusNone": "Kein Status",
        "notes": "Vertrauliche Notizen",
        "lastUpdate": "Zuletzt geändert {{date}} {{name}}",
        "saved": "Gespeichert.",
        "error": "Speichern fehlgeschlagen.",
        "statusUnknown": "Nicht mehr definiert",
        "notRated": "Nicht bewertet",
        "confidentialOwn": "Vertraulich: nur für das Portfoliomanagement und das Management Ihrer Einheit sichtbar. Übergeordnete Einheiten sehen diese Angaben nicht.",
        "rankPlaceholder": "z.B. 1",
        "saveView": "Sicht speichern",
        "newNote": "Neue Notiz",
        "notePlaceholder": "Neue Notiz für Ihre Einheit …",
        "addNote": "Notiz hinzufügen",
        "noteAddedAnnounce": "Notiz gespeichert.",
        "confirmDeleteNote": "Notiz wirklich löschen?",
        "noteDeletedAnnounce": "Notiz gelöscht.",
        "deleteNote": "Notiz löschen",
        "loadingNotes": "Notizen werden geladen …",
        "noNotes": "Noch keine Notizen.",
        "unknownAuthor": "Unbekannt",
        "legacyNote": "frühere Notiz"
    },
    "actions": {
        "reset": "Zurücksetzen"
    },
    "assessmentLifecycle": {
        "statusFinal": "Abgeschlossen",
        "statusSubmitted": "Eingereicht (extern)",
        "statusDraft": "Entwurf",
        "releasedByChild": "Freigegeben von {{unit}}",
        "releasedTo": "Freigegeben an {{unit}}",
        "error": "Aktion fehlgeschlagen.",
        "unknownUnit": "Organisationseinheit",
        "confidential": "Vertraulich (nur eigene Einheit)",
        "finalize": "Abschliessen",
        "finalizedAnnounce": "Assessment abgeschlossen.",
        "release": "An {{unit}} freigeben",
        "releasedAnnounce": "Assessment freigegeben.",
        "withdraw": "Freigabe zurückziehen",
        "withdrawnAnnounce": "Freigabe zurückgezogen.",
        "reopen": "Wieder öffnen",
        "reopenedAnnounce": "Assessment wieder geöffnet.",
        "hintNew": "Neue Bewertungen sind Entwürfe und nur in Ihrer Einheit sichtbar.",
        "hintDraft": "Ein abgeschlossenes Assessment ist unveränderlich und kann an die übergeordnete Einheit freigegeben werden.",
        "hintFinal": "Nach der Freigabe sieht {{unit}} das Assessment vollständig, inklusive Bemerkungen. Höhere Ebenen sehen es nicht einzeln; anonym fliesst es in den Gesamtdurchschnitt ein.",
        "hintForeign": "Von einer unterstellten Einheit freigegeben. Nur lesbar.",
        "saveFirst": "Bitte zuerst speichern, dann abschliessen."
    },
    "comparison": {
        "title": "Vergleich mit anderen Einheiten",
        "intro": "Nur Durchschnitte, Stand {{year}}. Jede Einheit zählt gleich viel.",
        "directColumn": "Einheiten direkt unter {{group}}",
        "overallColumn": "Alle Einheiten unter {{root}}",
        "explainDirect": "Einheiten direkt unter {{group}}: inkl. Ihrer Einheit, falls freigegeben; angezeigt ab {{min}} Einheiten. Basis: {{count}} von {{total}} Einheiten.",
        "explainDirectTop": "Einheiten direkt unter {{group}}: Ihre eigene Bewertung fliesst nicht ein. Basis: {{count}} von {{total}} Einheiten.",
        "explainOverall": "Alle Einheiten unter {{root}}: über alle Ebenen, ohne {{root}} selbst, in ganzen Prozent. Basis: {{count}} von {{total}} Einheiten.",
        "tooFew": "Zu wenige Einheiten direkt unter {{group}} für einen Vergleich (mindestens {{min}}).",
        "noReleases": "Noch keine freigegebenen Bewertungen von Einheiten direkt unter {{group}}.",
        "overallTooFew": "Noch zu wenige freigegebene Bewertungen für einen Gesamtdurchschnitt. Der Vergleich beschränkt sich auf die direkten Einheiten.",
        "caption": "Eigene Werte im Vergleich zu den Durchschnitten",
        "criterion": "Kriterium",
        "own": "Eigene Einheit",
        "difference": "Differenz",
        "total": "Gesamt"
    },
    "topics": {
        "validationRequired": "Name und zuständige Einheit sind erforderlich.",
        "savedAnnounce": "Querschnittsthema gespeichert.",
        "saveError": "Speichern fehlgeschlagen.",
        "confirmDelete": "Querschnittsthema \"{{name}}\" löschen? Es wird aus allen Projekten entfernt, die zuständige Einheit verliert den Zugriff.",
        "deletedAnnounce": "Querschnittsthema gelöscht.",
        "deleteError": "Löschen fehlgeschlagen.",
        "title": "Querschnittsthemen",
        "intro": "Kategorien quer zur Hierarchie mit zuständiger Einheit, z.B. Informatik oder Nachhaltigkeit. Sie erscheinen in allen Einheiten als Kategorie. Ordnet das Portfoliomanagement ein Projekt einem Querschnittsthema zu, wird es für die zuständige Einheit sichtbar (Projektdaten und Risiken, ohne Massnahmen).",
        "add": "Thema anlegen",
        "empty": "Noch keine Querschnittsthemen definiert.",
        "owner": "Zuständig",
        "inactive": "deaktiviert",
        "editNamed": "{{name}} bearbeiten",
        "activate": "Aktivieren",
        "deactivate": "Deaktivieren",
        "deleteNamed": "{{name}} löschen",
        "edit": "Thema bearbeiten",
        "name": "Name",
        "ownerUnit": "Zuständige Einheit",
        "ownerChangeHint": "Der Zugriff auf alle Projekte dieses Themas geht auf die neue Einheit über.",
        "description": "Beschreibung",
        "color": "Farbe"
    },
    "unitCategories": {
        "sectionTitle": "Kategorien: {{unit}}",
        "intro": "Eigene Kategorien sind nur für Ihre Einheit sichtbar und dienen zum Ordnen, Filtern und für Roadmaps; sie geben nichts frei.",
        "error": "Aktion fehlgeschlagen.",
        "empty": "Noch keine eigenen Kategorien.",
        "addedAnnounce": "Kategorie angelegt.",
        "updatedAnnounce": "Kategorie gespeichert.",
        "deletedAnnounce": "Kategorie gelöscht.",
        "colorFor": "Farbe von {{name}}",
        "nameFor": "Name von {{name}}",
        "confirmDelete": "Kategorie «{{name}}» löschen? Sie wird auch aus den Projekten entfernt.",
        "deleteNamed": "{{name}} löschen",
        "newColor": "Farbe der neuen Kategorie",
        "newName": "Name der neuen Kategorie",
        "placeholder": "z.B. Legislaturziel 3",
        "add": "Hinzufügen",
        "topicsTitle": "Querschnittsthemen",
        "topicsIntro": "Vom Mandanten vorgegeben und in allen Einheiten als Kategorie verfügbar. Die Zuordnung macht ein Projekt für die zuständige Einheit sichtbar.",
        "topicOwner": "zuständig: {{unit}}"
    },
    "unitStatuses": {
        "sectionTitle": "Status im Portfolio: {{unit}}",
        "intro": "Mit diesen Status ordnet Ihre Einheit Projekte in ihrer vertraulichen Sicht ein. Andere Einheiten sehen sie nicht.",
        "customHint": "Ihre Einheit verwendet eigene Status.",
        "defaultHint": "Derzeit gelten die Vorgaben; Änderungen speichern eine eigene Liste.",
        "nameFor": "Name von Status {{position}}",
        "moveUp": "{{name}} nach oben",
        "moveDown": "{{name}} nach unten",
        "remove": "{{name}} entfernen",
        "newName": "Name des neuen Status",
        "placeholder": "z.B. Zur Beratung in der Geschäftsleitung",
        "add": "Hinzufügen",
        "reset": "Vorgaben verwenden",
        "discard": "Verwerfen",
        "save": "Status speichern",
        "savedAnnounce": "Status gespeichert.",
        "savedCleared_one": "Status gespeichert. 1 Projekt hat keinen Status mehr.",
        "savedCleared_other": "Status gespeichert. {{count}} Projekte haben keinen Status mehr.",
        "error": "Speichern fehlgeschlagen.",
        "nameMissing": "Jeder Status braucht einen Namen.",
        "confirmRemove": "Entfernte Status ({{list}}) werden aus den Projekten Ihrer Einheit entfernt. Fortfahren?",
        "confirmReset": "Wieder die vorgegebenen Status verwenden? Projekte mit einem eigenen Status verlieren ihn."
    },
    "sharingBadge": {
        "receivedFrom": "Erhalten von {{unit}}",
        "receivedTopic": "Erhalten über das Querschnittsthema {{topic}}",
        "promotedTo": "Weitergegeben an {{unit}}",
        "sharedTopic": "Freigegeben für {{unit}} (Querschnittsthema {{topic}})"
    },
    "topicShare": {
        "title": "Freigabe an Querschnittsämter bestätigen",
        "gainAccess": "Erhalten Einblick in dieses Projekt (Projektdaten und Risiken, ohne Massnahmen):",
        "loseAccess": "Verlieren den Einblick:",
        "confirm": "Bestätigen und speichern"
    }
};
